var _rect, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _path10, _path11, _path12, _path13, _path14, _path15, _rect2, _path16, _path17, _path18, _path19, _rect3, _path20, _rect4, _circle, _path21, _rect5, _rect6, _rect7, _rect8, _mask2, _path22, _path23, _line, _line2, _path24, _path25, _rect9, _path26, _line3, _path27, _path28, _rect10, _path29, _rect11, _path30, _path31, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 196,
    viewBox: "0 0 132 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 103,
    height: 150,
    fill: "#2A2A2A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1596_3872",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11283 0C3.35064 0 0.300781 3.04986 0.300781 6.81206V188.467C0.300781 192.229 3.35065 195.279 7.11284 195.279H125.188C128.951 195.279 132 192.229 132 188.467V6.81205C132 3.04986 128.951 0 125.188 0H7.11283ZM102.125 33.2824H6.37602V163.716H102.125V33.2824Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11283 0C3.35064 0 0.300781 3.04986 0.300781 6.81206V188.467C0.300781 192.229 3.35065 195.279 7.11284 195.279H125.188C128.951 195.279 132 192.229 132 188.467V6.81205C132 3.04986 128.951 0 125.188 0H7.11283ZM102.125 33.2824H6.37602V163.716H102.125V33.2824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37602 33.2824V32.7919H5.88555V33.2824H6.37602ZM102.125 33.2824H102.615V32.7919H102.125V33.2824ZM6.37602 163.716H5.88555V164.206H6.37602V163.716ZM102.125 163.716V164.206H102.615V163.716H102.125ZM0.791249 6.81206C0.791249 3.32074 3.62152 0.490468 7.11283 0.490468V-0.490468C3.07976 -0.490468 -0.189687 2.77899 -0.189687 6.81206H0.791249ZM0.791249 188.467V6.81206H-0.189687V188.467H0.791249ZM7.11284 194.788C3.62153 194.788 0.791249 191.958 0.791249 188.467H-0.189687C-0.189687 192.5 3.07977 195.769 7.11284 195.769V194.788ZM125.188 194.788H7.11284V195.769H125.188V194.788ZM131.51 188.467C131.51 191.958 128.68 194.788 125.188 194.788V195.769C129.221 195.769 132.491 192.5 132.491 188.467H131.51ZM131.51 6.81205V188.467H132.491V6.81205H131.51ZM125.188 0.490468C128.68 0.490468 131.51 3.32074 131.51 6.81205H132.491C132.491 2.77898 129.221 -0.490468 125.188 -0.490468V0.490468ZM7.11283 0.490468H125.188V-0.490468H7.11283V0.490468ZM6.37602 33.7729H102.125V32.7919H6.37602V33.7729ZM6.86649 163.716V33.2824H5.88555V163.716H6.86649ZM102.125 163.225H6.37602V164.206H102.125V163.225ZM101.634 33.2824V163.716H102.615V33.2824H101.634Z",
    fill: "black",
    mask: "url(#path-2-inside-1_1596_3872)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21014 5.18495H8.57652V5.55134H8.21014V5.18495ZM9.67568 5.18495H10.0421V5.55134H9.67568V5.18495ZM9.67568 5.55134H10.0421V5.91773H9.67568V5.55134ZM10.0421 5.18495H10.4084V5.55134H10.0421V5.18495ZM10.0421 5.55134H10.4084V5.91773H10.0421V5.55134ZM10.0421 5.91773H10.4084V6.28411H10.0421V5.91773ZM10.0421 6.28411H10.4084V6.6505H10.0421V6.28411ZM10.0421 6.6505H10.4084V7.01688H10.0421V6.6505ZM10.0421 7.01688H10.4084V7.38327H10.0421V7.01688ZM10.0421 7.38327H10.4084V7.74965H10.0421V7.38327ZM10.0421 7.74965H10.4084V8.11604H10.0421V7.74965ZM9.67568 7.74965H10.0421V8.11604H9.67568V7.74965ZM9.67568 7.38327H10.0421V7.74965H9.67568V7.38327ZM9.67568 7.01688H10.0421V7.38327H9.67568V7.01688ZM9.67568 6.6505H10.0421V7.01688H9.67568V6.6505ZM9.67568 6.28411H10.0421V6.6505H9.67568V6.28411ZM9.67568 5.91773H10.0421V6.28411H9.67568V5.91773ZM9.30929 7.38327H9.67568V7.74965H9.30929V7.38327ZM9.30929 7.74965H9.67568V8.11604H9.30929V7.74965ZM9.67568 8.11604H10.0421V8.48242H9.67568V8.11604ZM9.30929 8.11604H9.67568V8.48242H9.30929V8.11604ZM8.94291 8.11604H9.30929V8.48242H8.94291V8.11604ZM8.94291 7.74965H9.30929V8.11604H8.94291V7.74965ZM8.57652 8.11604H8.94291V8.48242H8.57652V8.11604ZM8.21014 8.11604H8.57652V8.48242H8.21014V8.11604ZM8.21014 7.74965H8.57652V8.11604H8.21014V7.74965ZM8.57652 7.74965H8.94291V8.11604H8.57652V7.74965ZM8.57652 7.38327H8.94291V7.74965H8.57652V7.38327ZM8.21014 7.38327H8.57652V7.74965H8.21014V7.38327ZM7.84375 7.74965H8.21014V8.11604H7.84375V7.74965ZM7.84375 7.38327H8.21014V7.74965H7.84375V7.38327ZM7.84375 7.01688H8.21014V7.38327H7.84375V7.01688ZM7.84375 6.6505H8.21014V7.01688H7.84375V6.6505ZM7.84375 6.28411H8.21014V6.6505H7.84375V6.28411ZM7.84375 5.91773H8.21014V6.28411H7.84375V5.91773ZM7.84375 5.55134H8.21014V5.91773H7.84375V5.55134ZM8.21014 5.55134H8.57652V5.91773H8.21014V5.55134ZM7.84375 5.18495H8.21014V5.55134H7.84375V5.18495ZM8.21014 5.91773H8.57652V6.28411H8.21014V5.91773ZM8.21014 6.28411H8.57652V6.6505H8.21014V6.28411ZM8.21014 6.6505H8.57652V7.01688H8.21014V6.6505ZM8.21014 7.01688H8.57652V7.38327H8.21014V7.01688ZM7.84375 4.81857H8.21014V5.18495H7.84375V4.81857ZM8.21014 4.81857H8.57652V5.18495H8.21014V4.81857ZM9.67568 4.81857H10.0421V5.18495H9.67568V4.81857ZM10.0421 4.81857H10.4084V5.18495H10.0421V4.81857ZM10.7758 5.91773H11.1422V6.28411H10.7758V5.91773ZM10.7758 5.55134H11.1422V5.91773H10.7758V5.55134ZM11.1422 5.55134H11.5086V5.91773H11.1422V5.55134ZM11.1422 5.91773H11.5086V6.28411H11.1422V5.91773ZM11.1422 6.28411H11.5086V6.6505H11.1422V6.28411ZM11.1422 6.6505H11.5086V7.01688H11.1422V6.6505ZM11.1422 7.01688H11.5086V7.38327H11.1422V7.01688ZM10.7758 7.01688H11.1422V7.38327H10.7758V7.01688ZM10.7758 6.6505H11.1422V7.01688H10.7758V6.6505ZM10.7758 6.28411H11.1422V6.6505H10.7758V6.28411ZM10.7758 7.38327H11.1422V7.74965H10.7758V7.38327ZM11.1422 7.38327H11.5086V7.74965H11.1422V7.38327ZM11.1422 7.74965H11.5086V8.11604H11.1422V7.74965ZM11.1422 8.11604H11.5086V8.48242H11.1422V8.11604ZM10.7758 8.11604H11.1422V8.48242H10.7758V8.11604ZM10.7758 7.74965H11.1422V8.11604H10.7758V7.74965ZM12.6077 8.11604H12.9741V8.48242H12.6077V8.11604ZM12.9741 8.11604H13.3405V8.48242H12.9741V8.11604ZM12.9741 7.74965H13.3405V8.11604H12.9741V7.74965ZM12.9741 7.38327H13.3405V7.74965H12.9741V7.38327ZM12.9741 7.01688H13.3405V7.38327H12.9741V7.01688ZM12.9741 6.6505H13.3405V7.01688H12.9741V6.6505ZM12.9741 6.28411H13.3405V6.6505H12.9741V6.28411ZM12.9741 5.91773H13.3405V6.28411H12.9741V5.91773ZM12.6077 6.6505H12.9741V7.01688H12.6077V6.6505ZM12.6077 7.01688H12.9741V7.38327H12.6077V7.01688ZM12.6077 7.38327H12.9741V7.74965H12.6077V7.38327ZM12.6077 7.74965H12.9741V8.11604H12.6077V7.74965ZM12.6077 6.28411H12.9741V6.6505H12.6077V6.28411ZM11.5086 5.91773H11.8749V6.28411H11.5086V5.91773ZM11.8749 5.91773H12.2413V6.28411H11.8749V5.91773ZM12.2413 5.91773H12.6077V6.28411H12.2413V5.91773ZM12.2413 5.55134H12.6077V5.91773H12.2413V5.55134ZM12.6077 5.55134H12.9741V5.91773H12.6077V5.55134ZM12.6077 5.91773H12.9741V6.28411H12.6077V5.91773ZM11.8749 5.55134H12.2413V5.91773H11.8749V5.55134ZM15.1734 7.74965H15.5397V8.11604H15.1734V7.74965ZM15.1734 8.11604H15.5397V8.48242H15.1734V8.11604ZM14.807 8.11604H15.1734V8.48242H14.807V8.11604ZM14.807 7.74965H15.1734V8.11604H14.807V7.74965ZM14.4406 8.11604H14.807V8.48242H14.4406V8.11604ZM14.4406 7.74965H14.807V8.11604H14.4406V7.74965ZM14.0742 7.74965H14.4406V8.11604H14.0742V7.74965ZM14.0742 7.38327H14.4406V7.74965H14.0742V7.38327ZM14.0742 7.01688H14.4406V7.38327H14.0742V7.01688ZM14.0742 6.6505H14.4406V7.01688H14.0742V6.6505ZM14.0742 6.28411H14.4406V6.6505H14.0742V6.28411ZM14.0742 5.91773H14.4406V6.28411H14.0742V5.91773ZM14.4406 7.01688H14.807V7.38327H14.4406V7.01688ZM14.4406 7.38327H14.807V7.74965H14.4406V7.38327ZM14.4406 6.6505H14.807V7.01688H14.4406V6.6505ZM14.4406 6.28411H14.807V6.6505H14.4406V6.28411ZM14.4406 4.81857H14.807V5.18495H14.4406V4.81857ZM14.4406 5.18495H14.807V5.55134H14.4406V5.18495ZM14.4406 5.55134H14.807V5.91773H14.4406V5.55134ZM14.4406 5.91773H14.807V6.28411H14.4406V5.91773ZM14.0742 5.55134H14.4406V5.91773H14.0742V5.55134ZM13.7078 5.91773H14.0742V6.28411H13.7078V5.91773ZM14.807 5.91773H15.1734V6.28411H14.807V5.91773ZM15.1734 5.91773H15.5397V6.28411H15.1734V5.91773ZM14.0742 5.18495H14.4406V5.55134H14.0742V5.18495ZM13.7078 6.28411H14.0742V6.6505H13.7078V6.28411ZM14.807 6.28411H15.1734V6.6505H14.807V6.28411ZM15.1734 6.28411H15.5397V6.6505H15.1734V6.28411ZM15.9052 4.81857H16.6379V5.55134H15.9052V4.81857ZM15.9052 5.91773H16.6379V8.48242H15.9052V5.91773ZM18.4727 7.74965H18.8391V8.11604H18.4727V7.74965ZM18.4727 8.11604H18.8391V8.48242H18.4727V8.11604ZM18.1064 8.11604H18.4727V8.48242H18.1064V8.11604ZM18.1064 7.74965H18.4727V8.11604H18.1064V7.74965ZM17.74 8.11604H18.1064V8.48242H17.74V8.11604ZM17.74 7.74965H18.1064V8.11604H17.74V7.74965ZM17.3736 7.74965H17.74V8.11604H17.3736V7.74965ZM17.3736 7.38327H17.74V7.74965H17.3736V7.38327ZM17.3736 7.01688H17.74V7.38327H17.3736V7.01688ZM17.3736 6.6505H17.74V7.01688H17.3736V6.6505ZM17.3736 6.28411H17.74V6.6505H17.3736V6.28411ZM17.3736 5.91773H17.74V6.28411H17.3736V5.91773ZM17.74 7.01688H18.1064V7.38327H17.74V7.01688ZM17.74 7.38327H18.1064V7.74965H17.74V7.38327ZM17.74 6.6505H18.1064V7.01688H17.74V6.6505ZM17.74 6.28411H18.1064V6.6505H17.74V6.28411ZM17.74 4.81857H18.1064V5.18495H17.74V4.81857ZM17.74 5.18495H18.1064V5.55134H17.74V5.18495ZM17.74 5.55134H18.1064V5.91773H17.74V5.55134ZM17.74 5.91773H18.1064V6.28411H17.74V5.91773ZM17.3736 5.55134H17.74V5.91773H17.3736V5.55134ZM17.0072 5.91773H17.3736V6.28411H17.0072V5.91773ZM18.1064 5.91773H18.4727V6.28411H18.1064V5.91773ZM18.4727 5.91773H18.8391V6.28411H18.4727V5.91773ZM17.3736 5.18495H17.74V5.55134H17.3736V5.18495ZM17.0072 6.28411H17.3736V6.6505H17.0072V6.28411ZM18.1064 6.28411H18.4727V6.6505H18.1064V6.28411ZM18.4727 6.28411H18.8391V6.6505H18.4727V6.28411ZM19.2046 4.81857H19.5709V5.18495H19.2046V4.81857ZM19.5709 4.81857H19.9373V5.18495H19.5709V4.81857ZM19.5709 5.18495H19.9373V5.55134H19.5709V5.18495ZM19.5709 5.55134H19.9373V5.91773H19.5709V5.55134ZM19.5709 5.91773H19.9373V6.28411H19.5709V5.91773ZM19.5709 6.28411H19.9373V6.6505H19.5709V6.28411ZM19.5709 6.6505H19.9373V7.01688H19.5709V6.6505ZM19.2046 6.6505H19.5709V7.01688H19.2046V6.6505ZM19.2046 7.01688H19.5709V7.38327H19.2046V7.01688ZM19.2046 7.38327H19.5709V7.74965H19.2046V7.38327ZM19.2046 7.74965H19.5709V8.11604H19.2046V7.74965ZM19.2046 8.11604H19.5709V8.48242H19.2046V8.11604ZM19.5709 8.11604H19.9373V8.48242H19.5709V8.11604ZM19.5709 7.74965H19.9373V8.11604H19.5709V7.74965ZM19.5709 7.38327H19.9373V7.74965H19.5709V7.38327ZM19.5709 7.01688H19.9373V7.38327H19.5709V7.01688ZM19.2046 6.28411H19.5709V6.6505H19.2046V6.28411ZM19.2046 5.91773H19.5709V6.28411H19.2046V5.91773ZM19.2046 5.55134H19.5709V5.91773H19.2046V5.55134ZM19.2046 5.18495H19.5709V5.55134H19.2046V5.18495ZM21.0393 5.55134H21.4057V5.91773H21.0393V5.55134ZM20.673 5.55134H21.0393V5.91773H20.673V5.55134ZM20.673 5.91773H21.0393V6.28411H20.673V5.91773ZM21.0393 5.91773H21.4057V6.28411H21.0393V5.91773ZM21.4057 5.55134H21.7721V5.91773H21.4057V5.55134ZM21.7721 5.55134H22.1385V5.91773H21.7721V5.55134ZM22.1385 5.55134H22.5049V5.91773H22.1385V5.55134ZM22.1385 5.91773H22.5049V6.28411H22.1385V5.91773ZM21.7721 5.91773H22.1385V6.28411H21.7721V5.91773ZM22.5049 5.91773H22.8713V6.28411H22.5049V5.91773ZM22.5049 6.28411H22.8713V6.6505H22.5049V6.28411ZM22.5049 7.74965H22.8713V8.11604H22.5049V7.74965ZM22.1385 7.74965H22.5049V8.11604H22.1385V7.74965ZM22.1385 6.28411H22.5049V6.6505H22.1385V6.28411ZM21.7721 7.74965H22.1385V8.11604H21.7721V7.74965ZM22.1385 8.11604H22.5049V8.48242H22.1385V8.11604ZM21.7721 8.11604H22.1385V8.48242H21.7721V8.11604ZM21.4057 8.11604H21.7721V8.48242H21.4057V8.11604ZM21.0393 8.11604H21.4057V8.48242H21.0393V8.11604ZM20.673 8.11604H21.0393V8.48242H20.673V8.11604ZM20.673 7.74965H21.0393V8.11604H20.673V7.74965ZM21.0393 7.74965H21.4057V8.11604H21.0393V7.74965ZM20.673 7.38327H21.0393V7.74965H20.673V7.38327ZM20.3066 7.74965H20.673V8.11604H20.3066V7.74965ZM20.3066 7.38327H20.673V7.74965H20.3066V7.38327ZM20.3066 7.01688H20.673V7.38327H20.3066V7.01688ZM20.3066 6.6505H20.673V7.01688H20.3066V6.6505ZM20.3066 6.28411H20.673V6.6505H20.3066V6.28411ZM20.3066 5.91773H20.673V6.28411H20.3066V5.91773ZM20.673 6.28411H21.0393V6.6505H20.673V6.28411ZM20.673 6.6505H21.0393V7.01688H20.673V6.6505ZM20.673 7.01688H21.0393V7.38327H20.673V7.01688ZM21.4057 7.74965H21.7721V8.11604H21.4057V7.74965ZM21.4057 5.91773H21.7721V6.28411H21.4057V5.91773ZM22.1385 6.6505H22.5049V7.01688H22.1385V6.6505ZM22.5049 6.6505H22.8713V7.01688H22.5049V6.6505ZM21.0393 7.01688H21.4057V7.38327H21.0393V7.01688ZM21.4057 7.01688H21.7721V7.38327H21.4057V7.01688ZM21.7721 7.01688H22.1385V7.38327H21.7721V7.01688ZM22.1385 7.01688H22.5049V7.38327H22.1385V7.01688ZM22.5049 7.01688H22.8713V7.38327H22.5049V7.01688ZM21.7721 6.6505H22.1385V7.01688H21.7721V6.6505ZM21.4057 6.6505H21.7721V7.01688H21.4057V6.6505ZM21.0393 6.6505H21.4057V7.01688H21.0393V6.6505ZM25.8033 5.91773V6.28411H25.4369V5.91773H25.8033ZM25.8033 5.55134V5.91773H25.4369V5.55134H25.8033ZM25.4369 5.55134V5.91773H25.0705V5.55134H25.4369ZM25.4369 5.91773V6.28411H25.0705V5.91773H25.4369ZM25.4369 6.28411V6.6505H25.0705V6.28411H25.4369ZM25.4369 6.6505V7.01688H25.0705V6.6505H25.4369ZM25.4369 7.01688V7.38327H25.0705V7.01688H25.4369ZM25.8033 7.01688V7.38327H25.4369V7.01688H25.8033ZM25.8033 6.6505V7.01688H25.4369V6.6505H25.8033ZM25.8033 6.28411V6.6505H25.4369V6.28411H25.8033ZM25.8033 7.38327V7.74965H25.4369V7.38327H25.8033ZM25.4369 7.38327V7.74965H25.0705V7.38327H25.4369ZM25.4369 7.74965V8.11604H25.0705V7.74965H25.4369ZM25.4369 8.11604V8.48242H25.0705V8.11604H25.4369ZM25.8033 8.11604V8.48242H25.4369V8.11604H25.8033ZM25.8033 7.74965V8.11604H25.4369V7.74965H25.8033ZM23.9714 8.11604V8.48242H23.605V8.11604H23.9714ZM23.605 7.74965V8.11604H23.2386V7.74965H23.605ZM23.605 7.38327V7.74965H23.2386V7.38327H23.605ZM23.605 7.01688V7.38327H23.2386V7.01688H23.605ZM23.605 6.6505V7.01688H23.2386V6.6505H23.605ZM23.605 6.28411V6.6505H23.2386V6.28411H23.605ZM23.605 5.91773V6.28411H23.2386V5.91773H23.605ZM23.9714 6.6505V7.01688H23.605V6.6505H23.9714ZM23.9714 7.01688V7.38327H23.605V7.01688H23.9714ZM23.9714 7.38327V7.74965H23.605V7.38327H23.9714ZM23.9714 7.74965V8.11604H23.605V7.74965H23.9714ZM23.9714 6.28411V6.6505H23.605V6.28411H23.9714ZM24.3378 5.91773V6.28411H23.9714V5.91773H24.3378ZM24.3378 5.55134V5.91773H23.9714V5.55134H24.3378ZM23.9714 5.55134V5.91773H23.605V5.55134H23.9714ZM23.9714 5.91773V6.28411H23.605V5.91773H23.9714ZM24.7041 5.55134V5.91773H24.3378V5.55134H24.7041ZM25.8033 4.81857V5.18495H25.4369V4.81857H25.8033ZM25.4369 4.81857V5.18495H25.0705V4.81857H25.4369ZM25.4369 5.18495V5.55134H25.0705V5.18495H25.4369ZM25.8033 5.18495V5.55134H25.4369V5.18495H25.8033ZM24.7041 8.11604V8.48242H24.3378V8.11604H24.7041ZM24.3378 8.11604V8.48242H23.9714V8.11604H24.3378ZM24.3378 7.74965V8.11604H23.9714V7.74965H24.3378ZM24.7041 7.74965V8.11604H24.3378V7.74965H24.7041ZM25.0705 7.74965V8.11604H24.7041V7.74965H25.0705ZM25.0705 5.55134V5.91773H24.7041V5.55134H25.0705ZM25.0705 5.91773V6.28411H24.7041V5.91773H25.0705ZM24.7041 5.91773V6.28411H24.3378V5.91773H24.7041ZM27.6333 6.28411H27.9997V6.6505H27.6333V6.28411ZM27.9997 6.28411H28.3661V6.6505H27.9997V6.28411ZM28.3661 6.28411H28.7325V6.6505H28.3661V6.28411ZM28.7325 6.28411H29.0989V6.6505H28.7325V6.28411ZM29.0989 6.28411H29.4652V6.6505H29.0989V6.28411ZM29.4652 6.28411H29.8316V6.6505H29.4652V6.28411ZM29.4652 6.6505H29.8316V7.01688H29.4652V6.6505ZM29.0989 6.6505H29.4652V7.01688H29.0989V6.6505ZM28.7325 6.6505H29.0989V7.01688H28.7325V6.6505ZM28.3661 6.6505H28.7325V7.01688H28.3661V6.6505ZM27.9997 6.6505H28.3661V7.01688H27.9997V6.6505ZM27.6333 6.6505H27.9997V7.01688H27.6333V6.6505ZM31.6607 4.81857H32.0271V5.18495H31.6607V4.81857ZM32.0271 4.81857H32.3935V5.18495H32.0271V4.81857ZM32.3935 4.81857H32.7599V5.18495H32.3935V4.81857ZM32.7599 4.81857H33.1262V5.18495H32.7599V4.81857ZM33.1262 4.81857H33.4926V5.18495H33.1262V4.81857ZM33.4926 4.81857H33.859V5.18495H33.4926V4.81857ZM33.4926 5.18495H33.859V5.55134H33.4926V5.18495ZM33.1262 5.18495H33.4926V5.55134H33.1262V5.18495ZM32.7599 5.18495H33.1262V5.55134H32.7599V5.18495ZM32.3935 5.18495H32.7599V5.55134H32.3935V5.18495ZM32.0271 5.18495H32.3935V5.55134H32.0271V5.18495ZM31.6607 5.18495H32.0271V5.55134H31.6607V5.18495ZM33.859 5.18495H34.2254V5.55134H33.859V5.18495ZM33.4926 5.55134H33.859V5.91773H33.4926V5.55134ZM33.859 5.55134H34.2254V5.91773H33.859V5.55134ZM33.859 5.91773H34.2254V6.28411H33.859V5.91773ZM33.859 6.28411H34.2254V6.6505H33.859V6.28411ZM33.4926 6.28411H33.859V6.6505H33.4926V6.28411ZM33.4926 5.91773H33.859V6.28411H33.4926V5.91773ZM33.4926 6.6505H33.859V7.01688H33.4926V6.6505ZM33.4926 7.01688H33.859V7.38327H33.4926V7.01688ZM33.1262 7.01688H33.4926V7.38327H33.1262V7.01688ZM33.1262 6.6505H33.4926V7.01688H33.1262V6.6505ZM32.7599 6.6505H33.1262V7.01688H32.7599V6.6505ZM32.7599 7.01688H33.1262V7.38327H32.7599V7.01688ZM32.3935 7.01688H32.7599V7.38327H32.3935V7.01688ZM32.3935 6.6505H32.7599V7.01688H32.3935V6.6505ZM32.0271 6.6505H32.3935V7.01688H32.0271V6.6505ZM31.6607 6.6505H32.0271V7.01688H31.6607V6.6505ZM31.6607 7.01688H32.0271V7.38327H31.6607V7.01688ZM32.0271 7.01688H32.3935V7.38327H32.0271V7.01688ZM31.6607 5.55134H32.0271V5.91773H31.6607V5.55134ZM32.0271 5.55134H32.3935V5.91773H32.0271V5.55134ZM32.0271 5.91773H32.3935V6.28411H32.0271V5.91773ZM32.0271 6.28411H32.3935V6.6505H32.0271V6.28411ZM31.6607 5.91773H32.0271V6.28411H31.6607V5.91773ZM31.6607 6.28411H32.0271V6.6505H31.6607V6.28411ZM31.6607 7.38327H32.0271V7.74965H31.6607V7.38327ZM32.0271 7.38327H32.3935V7.74965H32.0271V7.38327ZM32.0271 7.74965H32.3935V8.11604H32.0271V7.74965ZM32.0271 8.11604H32.3935V8.48242H32.0271V8.11604ZM31.6607 8.11604H32.0271V8.48242H31.6607V8.11604ZM31.6607 7.74965H32.0271V8.11604H31.6607V7.74965ZM33.859 6.6505H34.2254V7.01688H33.859V6.6505ZM36.791 8.48242H36.4247V8.11604H36.791V8.48242ZM36.791 8.11604H36.4247V7.74965H36.791V8.11604ZM36.4247 8.11604H36.0583V7.74965H36.4247V8.11604ZM36.0583 8.48242H35.6919V8.11604H36.0583V8.48242ZM35.6919 8.48242H35.3255V8.11604H35.6919V8.48242ZM35.3255 8.48242H34.9591V8.11604H35.3255V8.48242ZM35.3255 8.11604H34.9591V7.74965H35.3255V8.11604ZM35.6919 8.11604H35.3255V7.74965H35.6919V8.11604ZM34.9591 8.11604H34.5927V7.74965H34.9591V8.11604ZM34.9591 7.74965H34.5927V7.38327H34.9591V7.74965ZM34.9591 6.28411H34.5927V5.91773H34.9591V6.28411ZM35.3255 6.28411H34.9591V5.91773H35.3255V6.28411ZM35.3255 7.74965H34.9591V7.38327H35.3255V7.74965ZM35.6919 6.28411H35.3255V5.91773H35.6919V6.28411ZM35.3255 5.91773H34.9591V5.55134H35.3255V5.91773ZM35.6919 5.91773H35.3255V5.55134H35.6919V5.91773ZM36.0583 5.91773H35.6919V5.55134H36.0583V5.91773ZM36.4247 5.91773H36.0583V5.55134H36.4247V5.91773ZM36.791 5.91773H36.4247V5.55134H36.791V5.91773ZM36.791 6.28411H36.4247V5.91773H36.791V6.28411ZM36.4247 6.28411H36.0583V5.91773H36.4247V6.28411ZM36.791 6.6505H36.4247V6.28411H36.791V6.6505ZM37.1574 6.28411H36.791V5.91773H37.1574V6.28411ZM37.1574 6.6505H36.791V6.28411H37.1574V6.6505ZM37.1574 7.01688H36.791V6.6505H37.1574V7.01688ZM37.1574 7.38327H36.791V7.01688H37.1574V7.38327ZM37.1574 7.74965H36.791V7.38327H37.1574V7.74965ZM37.1574 8.11604H36.791V7.74965H37.1574V8.11604ZM36.791 7.74965H36.4247V7.38327H36.791V7.74965ZM36.791 7.38327H36.4247V7.01688H36.791V7.38327ZM36.791 7.01688H36.4247V6.6505H36.791V7.01688ZM36.0583 6.28411H35.6919V5.91773H36.0583V6.28411ZM36.0583 8.11604H35.6919V7.74965H36.0583V8.11604ZM36.791 8.11604H37.1574V8.48242H36.791V8.11604ZM36.0583 6.6505H36.4247V7.01688H36.0583V6.6505ZM35.6919 6.6505H36.0583V7.01688H35.6919V6.6505ZM35.3255 6.6505H35.6919V7.01688H35.3255V6.6505ZM34.9591 6.6505H35.3255V7.01688H34.9591V6.6505ZM34.5927 7.01688H34.9591V7.38327H34.5927V7.01688ZM34.9591 7.01688H35.3255V7.38327H34.9591V7.01688ZM36.0583 7.01688H36.4247V7.38327H36.0583V7.01688ZM35.6919 7.01688H36.0583V7.38327H35.6919V7.01688ZM35.3255 7.01688H35.6919V7.38327H35.3255V7.01688ZM37.5248 4.81857H38.2575V5.55134H37.5248V4.81857ZM37.5248 5.91773H38.2575V8.48242H37.5248V5.91773ZM38.6268 5.91773H38.9932V6.28411H38.6268V5.91773ZM38.6268 5.55134H38.9932V5.91773H38.6268V5.55134ZM38.9932 5.55134H39.3596V5.91773H38.9932V5.55134ZM38.9932 5.91773H39.3596V6.28411H38.9932V5.91773ZM38.9932 6.28411H39.3596V6.6505H38.9932V6.28411ZM38.9932 6.6505H39.3596V7.01688H38.9932V6.6505ZM38.9932 7.01688H39.3596V7.38327H38.9932V7.01688ZM38.6268 7.01688H38.9932V7.38327H38.6268V7.01688ZM38.6268 6.6505H38.9932V7.01688H38.6268V6.6505ZM38.6268 6.28411H38.9932V6.6505H38.6268V6.28411ZM38.6268 7.38327H38.9932V7.74965H38.6268V7.38327ZM38.9932 7.38327H39.3596V7.74965H38.9932V7.38327ZM38.9932 7.74965H39.3596V8.11604H38.9932V7.74965ZM38.9932 8.11604H39.3596V8.48242H38.9932V8.11604ZM38.6268 8.11604H38.9932V8.48242H38.6268V8.11604ZM38.6268 7.74965H38.9932V8.11604H38.6268V7.74965ZM40.4587 8.11604H40.8251V8.48242H40.4587V8.11604ZM40.8251 8.11604H41.1915V8.48242H40.8251V8.11604ZM40.8251 7.74965H41.1915V8.11604H40.8251V7.74965ZM40.8251 7.38327H41.1915V7.74965H40.8251V7.38327ZM40.8251 7.01688H41.1915V7.38327H40.8251V7.01688ZM40.8251 6.6505H41.1915V7.01688H40.8251V6.6505ZM40.8251 6.28411H41.1915V6.6505H40.8251V6.28411ZM40.8251 5.91773H41.1915V6.28411H40.8251V5.91773ZM40.4587 6.6505H40.8251V7.01688H40.4587V6.6505ZM40.4587 7.01688H40.8251V7.38327H40.4587V7.01688ZM40.4587 7.38327H40.8251V7.74965H40.4587V7.38327ZM40.4587 7.74965H40.8251V8.11604H40.4587V7.74965ZM40.4587 6.28411H40.8251V6.6505H40.4587V6.28411ZM39.3596 5.91773H39.7259V6.28411H39.3596V5.91773ZM39.7259 5.91773H40.0923V6.28411H39.7259V5.91773ZM40.0923 5.91773H40.4587V6.28411H40.0923V5.91773ZM40.0923 5.55134H40.4587V5.91773H40.0923V5.55134ZM40.4587 5.55134H40.8251V5.91773H40.4587V5.55134ZM40.4587 5.91773H40.8251V6.28411H40.4587V5.91773ZM39.7259 5.55134H40.0923V5.91773H39.7259V5.55134ZM43.0244 7.74965H43.3907V8.11604H43.0244V7.74965ZM43.0244 8.11604H43.3907V8.48242H43.0244V8.11604ZM42.658 8.11604H43.0244V8.48242H42.658V8.11604ZM42.658 7.74965H43.0244V8.11604H42.658V7.74965ZM42.2916 8.11604H42.658V8.48242H42.2916V8.11604ZM42.2916 7.74965H42.658V8.11604H42.2916V7.74965ZM41.9252 7.74965H42.2916V8.11604H41.9252V7.74965ZM41.9252 7.38327H42.2916V7.74965H41.9252V7.38327ZM41.9252 7.01688H42.2916V7.38327H41.9252V7.01688ZM41.9252 6.6505H42.2916V7.01688H41.9252V6.6505ZM41.9252 6.28411H42.2916V6.6505H41.9252V6.28411ZM41.9252 5.91773H42.2916V6.28411H41.9252V5.91773ZM42.2916 7.01688H42.658V7.38327H42.2916V7.01688ZM42.2916 7.38327H42.658V7.74965H42.2916V7.38327ZM42.2916 6.6505H42.658V7.01688H42.2916V6.6505ZM42.2916 6.28411H42.658V6.6505H42.2916V6.28411ZM42.2916 4.81857H42.658V5.18495H42.2916V4.81857ZM42.2916 5.18495H42.658V5.55134H42.2916V5.18495ZM42.2916 5.55134H42.658V5.91773H42.2916V5.55134ZM42.2916 5.91773H42.658V6.28411H42.2916V5.91773ZM41.9252 5.55134H42.2916V5.91773H41.9252V5.55134ZM41.5588 5.91773H41.9252V6.28411H41.5588V5.91773ZM42.658 5.91773H43.0244V6.28411H42.658V5.91773ZM43.0244 5.91773H43.3907V6.28411H43.0244V5.91773ZM41.9252 5.18495H42.2916V5.55134H41.9252V5.18495ZM41.5588 6.28411H41.9252V6.6505H41.5588V6.28411ZM42.658 6.28411H43.0244V6.6505H42.658V6.28411ZM43.0244 6.28411H43.3907V6.6505H43.0244V6.28411Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13488 163.959H124.355V186.675C124.355 187.08 124.027 187.408 123.622 187.408H6.86765C6.46295 187.408 6.13488 187.08 6.13488 186.675V163.959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.488514
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 23.5112C5.89062 22.9716 6.32806 22.5342 6.86765 22.5342H123.622C124.162 22.5342 124.599 22.9716 124.599 23.5112V33.2815H5.89062V23.5112Z",
    fill: "url(#paint0_linear_1596_3872)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13488 23.5112C6.13488 23.1065 6.46295 22.7784 6.86765 22.7784H123.622C124.027 22.7784 124.355 23.1065 124.355 23.5112V33.0372H6.13488V23.5112Z",
    stroke: "black",
    strokeWidth: 0.488514
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7461 0H88.4474V8.30473C88.4474 8.84433 88.01 9.28176 87.4704 9.28176H76.7231C76.1835 9.28176 75.7461 8.84433 75.7461 8.30473V0Z",
    fill: "url(#paint1_linear_1596_3872)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9904 0.244257H88.2032V8.30473C88.2032 8.70943 87.8751 9.0375 87.4704 9.0375H76.7231C76.3184 9.0375 75.9904 8.70943 75.9904 8.30473V0.244257Z",
    stroke: "black",
    strokeWidth: 0.488514
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9609 0H100.662V8.30473C100.662 8.84433 100.225 9.28176 99.6853 9.28176H88.938C88.3984 9.28176 87.9609 8.84433 87.9609 8.30473V0Z",
    fill: "url(#paint2_linear_1596_3872)",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2052 0.244257H100.418V8.30473C100.418 8.70943 100.09 9.0375 99.6853 9.0375H88.938C88.5333 9.0375 88.2052 8.70943 88.2052 8.30473V0.244257Z",
    stroke: "black",
    strokeWidth: 0.488514
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.172 0H124.109V8.30473C124.109 8.84433 123.672 9.28176 123.132 9.28176H101.149C100.609 9.28176 100.172 8.84433 100.172 8.30473V0Z",
    fill: "url(#paint3_linear_1596_3872)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.416 0.244257H123.865V8.30473C123.865 8.70943 123.537 9.0375 123.132 9.0375H101.149C100.744 9.0375 100.416 8.70943 100.416 8.30473V0.244257Z",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.373 33.0382H124.356V163.96H102.373V33.0382Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.488514
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.82422,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#9E9E9E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.9023,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#675D4B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.3594,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.4414,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#464646"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.82422,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#2A2A2A"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.9023,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#CCCCCC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.3594,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#6B6B6B"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.4414,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.9883,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.0742,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5234,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#4F4F4F"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6094,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#A1A1A1"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.9883,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#DCDCDC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.0742,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#8B8B8B"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5234,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#EFEFEF"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6094,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#555555"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.1523,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#99886A"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2383,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#D1D1D1"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.6953,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#4F4F4F"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.7773,
    y: 168.111,
    width: 6.96151,
    height: 6.96151,
    fill: "#7B7B7B"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.1523,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2383,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.6953,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.7773,
    y: 176.234,
    width: 6.96151,
    height: 6.96151,
    fill: "#C7C7C7"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_dii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.035,
    y: 168.111,
    width: 15.0833,
    height: 15.0833,
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.125,
    y: 170.626,
    width: 6.96151,
    height: 6.96151,
    fill: "#9B9B9B"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.645,
    y: 174.146,
    width: 6.96151,
    height: 6.96151,
    fill: "#E9E9E9"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_ii_1596_3872)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.035,
    y: 122.681,
    width: 15.1439,
    height: 29.3108,
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1808 29.149H38.521V29.4893H38.1808V29.149ZM38.1808 28.8088H38.521V29.149H38.1808V28.8088ZM38.1808 28.4686H38.521V28.8088H38.1808V28.4686ZM37.8406 28.8088H38.1808V29.149H37.8406V28.8088ZM37.8406 28.4686H38.1808V28.8088H37.8406V28.4686ZM37.8406 28.1284H38.1808V28.4686H37.8406V28.1284ZM37.5004 28.4686H37.8406V28.8088H37.5004V28.4686ZM37.5004 28.1284H37.8406V28.4686H37.5004V28.1284ZM38.521 28.4686H38.8612V28.8088H38.521V28.4686ZM38.521 28.8088H38.8612V29.149H38.521V28.8088ZM38.521 28.1284H38.8612V28.4686H38.521V28.1284ZM38.8612 28.1284H39.2014V28.4686H38.8612V28.1284ZM38.8612 28.4686H39.2014V28.8088H38.8612V28.4686ZM39.2014 28.1284H39.5417V28.4686H39.2014V28.1284ZM37.1602 28.1284H37.5004V28.4686H37.1602V28.1284ZM38.8612 26.0871H39.2014V26.4273H38.8612V26.0871ZM39.2014 26.0871H39.5417V26.4273H39.2014V26.0871ZM39.2014 26.4273H39.5417V26.7675H39.2014V26.4273ZM39.2014 26.7675H39.5417V27.1078H39.2014V26.7675ZM39.2014 27.1078H39.5417V27.448H39.2014V27.1078ZM39.2014 27.448H39.5417V27.7882H39.2014V27.448ZM38.8612 27.448H39.2014V27.7882H38.8612V27.448ZM38.8612 27.7882H39.2014V28.1284H38.8612V27.7882ZM38.8612 27.1078H39.2014V27.448H38.8612V27.1078ZM38.8612 26.7675H39.2014V27.1078H38.8612V26.7675ZM38.8612 26.4273H39.2014V26.7675H38.8612V26.4273ZM39.2014 27.7882H39.5417V28.1284H39.2014V27.7882ZM37.5004 27.7882H37.8406V28.1284H37.5004V27.7882ZM37.1602 27.7882H37.5004V28.1284H37.1602V27.7882ZM37.1602 27.448H37.5004V27.7882H37.1602V27.448ZM37.5004 27.448H37.8406V27.7882H37.5004V27.448ZM37.5004 27.1078H37.8406V27.448H37.5004V27.1078ZM37.1602 27.1078H37.5004V27.448H37.1602V27.1078ZM37.1602 26.7675H37.5004V27.1078H37.1602V26.7675ZM37.5004 26.7675H37.8406V27.1078H37.5004V26.7675ZM37.1602 26.0871H37.5004V26.4273H37.1602V26.0871ZM37.5004 26.0871H37.8406V26.4273H37.5004V26.0871ZM37.5004 26.4273H37.8406V26.7675H37.5004V26.4273ZM37.1602 26.4273H37.5004V26.7675H37.1602V26.4273ZM39.8828 26.0871H40.5632V26.7675H39.8828V26.0871ZM39.8828 27.1078H40.5632V29.4893H39.8828V27.1078ZM41.5865 26.7675H41.9267V27.1078H41.5865V26.7675ZM41.2463 26.7675H41.5865V27.1078H41.2463V26.7675ZM41.2463 27.1078H41.5865V27.448H41.2463V27.1078ZM41.5865 27.1078H41.9267V27.448H41.5865V27.1078ZM41.9267 26.7675H42.2669V27.1078H41.9267V26.7675ZM42.2669 26.7675H42.6071V27.1078H42.2669V26.7675ZM42.6071 26.7675H42.9474V27.1078H42.6071V26.7675ZM42.6071 27.1078H42.9474V27.448H42.6071V27.1078ZM42.2669 27.1078H42.6071V27.448H42.2669V27.1078ZM42.9474 27.1078H43.2876V27.448H42.9474V27.1078ZM42.9474 27.448H43.2876V27.7882H42.9474V27.448ZM42.9474 28.8088H43.2876V29.149H42.9474V28.8088ZM42.6071 28.8088H42.9474V29.149H42.6071V28.8088ZM42.6071 27.448H42.9474V27.7882H42.6071V27.448ZM42.2669 28.8088H42.6071V29.149H42.2669V28.8088ZM42.6071 29.149H42.9474V29.4893H42.6071V29.149ZM42.2669 29.149H42.6071V29.4893H42.2669V29.149ZM41.9267 29.149H42.2669V29.4893H41.9267V29.149ZM41.5865 29.149H41.9267V29.4893H41.5865V29.149ZM41.2463 29.149H41.5865V29.4893H41.2463V29.149ZM41.2463 28.8088H41.5865V29.149H41.2463V28.8088ZM41.5865 28.8088H41.9267V29.149H41.5865V28.8088ZM41.2463 28.4686H41.5865V28.8088H41.2463V28.4686ZM40.9061 28.8088H41.2463V29.149H40.9061V28.8088ZM40.9061 28.4686H41.2463V28.8088H40.9061V28.4686ZM40.9061 28.1284H41.2463V28.4686H40.9061V28.1284ZM40.9061 27.7882H41.2463V28.1284H40.9061V27.7882ZM40.9061 27.448H41.2463V27.7882H40.9061V27.448ZM40.9061 27.1078H41.2463V27.448H40.9061V27.1078ZM41.2463 27.448H41.5865V27.7882H41.2463V27.448ZM41.2463 27.7882H41.5865V28.1284H41.2463V27.7882ZM41.2463 28.1284H41.5865V28.4686H41.2463V28.1284ZM41.9267 28.8088H42.2669V29.149H41.9267V28.8088ZM41.9267 27.1078H42.2669V27.448H41.9267V27.1078ZM42.6071 27.7882H42.9474V28.1284H42.6071V27.7882ZM42.9474 27.7882H43.2876V28.1284H42.9474V27.7882ZM41.5865 28.1284H41.9267V28.4686H41.5865V28.1284ZM41.9267 28.1284H42.2669V28.4686H41.9267V28.1284ZM42.2669 28.1284H42.6071V28.4686H42.2669V28.1284ZM42.6071 28.1284H42.9474V28.4686H42.6071V28.1284ZM42.9474 28.1284H43.2876V28.4686H42.9474V28.1284ZM42.2669 27.7882H42.6071V28.1284H42.2669V27.7882ZM41.9267 27.7882H42.2669V28.1284H41.9267V27.7882ZM41.5865 27.7882H41.9267V28.1284H41.5865V27.7882ZM43.6287 26.7675H43.9689V27.1078H43.6287V26.7675ZM43.6287 27.1078H43.9689V27.448H43.6287V27.1078ZM43.6287 27.448H43.9689V27.7882H43.6287V27.448ZM43.6287 27.7882H43.9689V28.1284H43.6287V27.7882ZM43.6287 28.1284H43.9689V28.4686H43.6287V28.1284ZM43.6287 28.4686H43.9689V28.8088H43.6287V28.4686ZM43.9689 28.4686H44.3091V28.8088H43.9689V28.4686ZM43.9689 28.8088H44.3091V29.149H43.9689V28.8088ZM44.3091 28.8088H44.6493V29.149H44.3091V28.8088ZM44.3091 29.149H44.6493V29.4893H44.3091V29.149ZM44.6493 28.8088H44.9895V29.149H44.6493V28.8088ZM44.9895 28.4686H45.3297V28.8088H44.9895V28.4686ZM45.3297 27.448H45.67V27.7882H45.3297V27.448ZM44.9895 26.7675H45.3297V27.1078H44.9895V26.7675ZM45.3297 26.7675H45.67V27.1078H45.3297V26.7675ZM45.3297 27.1078H45.67V27.448H45.3297V27.1078ZM45.3297 27.7882H45.67V28.1284H45.3297V27.7882ZM45.3297 28.1284H45.67V28.4686H45.3297V28.1284ZM44.9895 28.1284H45.3297V28.4686H44.9895V28.1284ZM44.9895 27.7882H45.3297V28.1284H44.9895V27.7882ZM44.9895 27.448H45.3297V27.7882H44.9895V27.448ZM44.9895 27.1078H45.3297V27.448H44.9895V27.1078ZM45.3297 28.4686H45.67V28.8088H45.3297V28.4686ZM46.0102 28.8088H46.3504V29.149H46.0102V28.8088ZM46.0102 29.149H46.3504V29.4893H46.0102V29.149ZM46.3504 28.8088H46.6906V29.149H46.3504V28.8088ZM46.3504 28.4686H46.6906V28.8088H46.3504V28.4686ZM46.6906 28.4686H47.0308V28.8088H46.6906V28.4686ZM46.6906 28.1284H47.0308V28.4686H46.6906V28.1284ZM46.6906 27.7882H47.0308V28.1284H46.6906V27.7882ZM46.6906 27.448H47.0308V27.7882H46.6906V27.448ZM46.6906 27.1078H47.0308V27.448H46.6906V27.1078ZM46.6906 26.7675H47.0308V27.1078H46.6906V26.7675ZM43.9689 27.1078H44.3091V27.448H43.9689V27.1078ZM43.9689 27.448H44.3091V27.7882H43.9689V27.448ZM43.9689 27.7882H44.3091V28.1284H43.9689V27.7882ZM43.9689 28.1284H44.3091V28.4686H43.9689V28.1284ZM43.9689 26.7675H44.3091V27.1078H43.9689V26.7675ZM46.3504 26.7675H46.6906V27.1078H46.3504V26.7675ZM46.3504 27.1078H46.6906V27.448H46.3504V27.1078ZM46.3504 27.448H46.6906V27.7882H46.3504V27.448ZM46.3504 27.7882H46.6906V28.1284H46.3504V27.7882ZM46.3504 28.1284H46.6906V28.4686H46.3504V28.1284ZM44.6493 29.149H44.9895V29.4893H44.6493V29.149ZM44.9895 28.8088H45.3297V29.149H44.9895V28.8088ZM45.3297 28.8088H45.67V29.149H45.3297V28.8088ZM45.67 28.8088H46.0102V29.149H45.67V28.8088ZM45.67 29.149H46.0102V29.4893H45.67V29.149ZM44.3091 28.4686H44.6493V28.8088H44.3091V28.4686ZM46.0102 28.4686H46.3504V28.8088H46.0102V28.4686Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.989 26.0871H74.3292V26.4273H73.989V26.0871ZM73.6488 26.0871H73.989V26.4273H73.6488V26.0871ZM73.6488 26.4273H73.989V26.7675H73.6488V26.4273ZM73.989 26.4273H74.3292V26.7675H73.989V26.4273ZM74.3292 26.4273H74.6695V26.7675H74.3292V26.4273ZM74.3292 26.0871H74.6695V26.4273H74.3292V26.0871ZM74.6695 26.0871H75.0097V26.4273H74.6695V26.0871ZM75.0097 26.0871H75.3499V26.4273H75.0097V26.0871ZM75.0097 26.4273H75.3499V26.7675H75.0097V26.4273ZM74.6695 26.4273H75.0097V26.7675H74.6695V26.4273ZM75.0097 26.7675H75.3499V27.1078H75.0097V26.7675ZM75.3499 26.4273H75.6901V26.7675H75.3499V26.4273ZM75.3499 26.7675H75.6901V27.1078H75.3499V26.7675ZM75.3499 28.4686H75.6901V28.8088H75.3499V28.4686ZM75.3499 28.8088H75.6901V29.149H75.3499V28.8088ZM75.0097 28.8088H75.3499V29.149H75.0097V28.8088ZM75.0097 28.4686H75.3499V28.8088H75.0097V28.4686ZM74.6695 28.8088H75.0097V29.149H74.6695V28.8088ZM75.0097 29.149H75.3499V29.4893H75.0097V29.149ZM74.6695 29.149H75.0097V29.4893H74.6695V29.149ZM74.3292 29.149H74.6695V29.4893H74.3292V29.149ZM74.3292 28.8088H74.6695V29.149H74.3292V28.8088ZM73.989 29.149H74.3292V29.4893H73.989V29.149ZM73.6488 29.149H73.989V29.4893H73.6488V29.149ZM73.6488 28.8088H73.989V29.149H73.6488V28.8088ZM73.989 28.8088H74.3292V29.149H73.989V28.8088ZM73.989 28.4686H74.3292V28.8088H73.989V28.4686ZM73.6488 28.4686H73.989V28.8088H73.6488V28.4686ZM73.3086 28.8088H73.6488V29.149H73.3086V28.8088ZM73.3086 28.4686H73.6488V28.8088H73.3086V28.4686ZM73.3086 28.1284H73.6488V28.4686H73.3086V28.1284ZM73.3086 27.7882H73.6488V28.1284H73.3086V27.7882ZM73.3086 27.448H73.6488V27.7882H73.3086V27.448ZM73.3086 27.1078H73.6488V27.448H73.3086V27.1078ZM73.3086 26.7675H73.6488V27.1078H73.3086V26.7675ZM73.6488 26.7675H73.989V27.1078H73.6488V26.7675ZM73.3086 26.4273H73.6488V26.7675H73.3086V26.4273ZM73.989 26.7675H74.3292V27.1078H73.989V26.7675ZM73.6488 27.1078H73.989V27.448H73.6488V27.1078ZM73.6488 27.448H73.989V27.7882H73.6488V27.448ZM73.6488 27.7882H73.989V28.1284H73.6488V27.7882ZM73.6488 28.1284H73.989V28.4686H73.6488V28.1284ZM76.7116 26.7675H77.0518V27.1078H76.7116V26.7675ZM76.3714 26.7675H76.7116V27.1078H76.3714V26.7675ZM76.3714 27.1078H76.7116V27.448H76.3714V27.1078ZM76.7116 27.1078H77.0518V27.448H76.7116V27.1078ZM77.0518 26.7675H77.3921V27.1078H77.0518V26.7675ZM77.3921 26.7675H77.7323V27.1078H77.3921V26.7675ZM77.7323 26.7675H78.0725V27.1078H77.7323V26.7675ZM77.7323 27.1078H78.0725V27.448H77.7323V27.1078ZM77.3921 27.1078H77.7323V27.448H77.3921V27.1078ZM77.7323 27.7882H78.0725V28.1284H77.7323V27.7882ZM78.0725 27.1078H78.4127V27.448H78.0725V27.1078ZM78.0725 27.448H78.4127V27.7882H78.0725V27.448ZM78.0725 27.7882H78.4127V28.1284H78.0725V27.7882ZM78.0725 28.1284H78.4127V28.4686H78.0725V28.1284ZM78.0725 28.4686H78.4127V28.8088H78.0725V28.4686ZM78.0725 28.8088H78.4127V29.149H78.0725V28.8088ZM77.7323 28.8088H78.0725V29.149H77.7323V28.8088ZM77.7323 28.4686H78.0725V28.8088H77.7323V28.4686ZM77.7323 28.1284H78.0725V28.4686H77.7323V28.1284ZM77.7323 27.448H78.0725V27.7882H77.7323V27.448ZM77.3921 28.8088H77.7323V29.149H77.3921V28.8088ZM77.7323 29.149H78.0725V29.4893H77.7323V29.149ZM77.3921 29.149H77.7323V29.4893H77.3921V29.149ZM77.0518 29.149H77.3921V29.4893H77.0518V29.149ZM76.7116 29.149H77.0518V29.4893H76.7116V29.149ZM76.3714 29.149H76.7116V29.4893H76.3714V29.149ZM76.3714 28.8088H76.7116V29.149H76.3714V28.8088ZM76.7116 28.8088H77.0518V29.149H76.7116V28.8088ZM76.3714 28.4686H76.7116V28.8088H76.3714V28.4686ZM76.0312 28.8088H76.3714V29.149H76.0312V28.8088ZM76.0312 28.4686H76.3714V28.8088H76.0312V28.4686ZM76.0312 28.1284H76.3714V28.4686H76.0312V28.1284ZM76.0312 27.7882H76.3714V28.1284H76.0312V27.7882ZM76.0312 27.448H76.3714V27.7882H76.0312V27.448ZM76.0312 27.1078H76.3714V27.448H76.0312V27.1078ZM76.3714 27.448H76.7116V27.7882H76.3714V27.448ZM76.3714 27.7882H76.7116V28.1284H76.3714V27.7882ZM76.3714 28.1284H76.7116V28.4686H76.3714V28.1284ZM77.0518 28.8088H77.3921V29.149H77.0518V28.8088ZM77.0518 27.1078H77.3921V27.448H77.0518V27.1078ZM78.7538 26.0871H79.094V26.4273H78.7538V26.0871ZM79.094 26.0871H79.4342V26.4273H79.094V26.0871ZM79.094 26.4273H79.4342V26.7675H79.094V26.4273ZM79.094 26.7675H79.4342V27.1078H79.094V26.7675ZM79.094 27.1078H79.4342V27.448H79.094V27.1078ZM79.094 27.448H79.4342V27.7882H79.094V27.448ZM79.094 27.7882H79.4342V28.1284H79.094V27.7882ZM78.7538 27.7882H79.094V28.1284H78.7538V27.7882ZM78.7538 28.1284H79.094V28.4686H78.7538V28.1284ZM78.7538 28.4686H79.094V28.8088H78.7538V28.4686ZM78.7538 28.8088H79.094V29.149H78.7538V28.8088ZM78.7538 29.149H79.094V29.4893H78.7538V29.149ZM79.094 29.149H79.4342V29.4893H79.094V29.149ZM79.094 28.8088H79.4342V29.149H79.094V28.8088ZM79.094 28.4686H79.4342V28.8088H79.094V28.4686ZM79.094 28.1284H79.4342V28.4686H79.094V28.1284ZM78.7538 27.448H79.094V27.7882H78.7538V27.448ZM78.7538 27.1078H79.094V27.448H78.7538V27.1078ZM78.7538 26.7675H79.094V27.1078H78.7538V26.7675ZM78.7538 26.4273H79.094V26.7675H78.7538V26.4273ZM80.4575 26.7675H80.7978V27.1078H80.4575V26.7675ZM80.1173 26.7675H80.4575V27.1078H80.1173V26.7675ZM80.1173 27.1078H80.4575V27.448H80.1173V27.1078ZM80.4575 27.1078H80.7978V27.448H80.4575V27.1078ZM80.7978 26.7675H81.138V27.1078H80.7978V26.7675ZM81.138 26.7675H81.4782V27.1078H81.138V26.7675ZM81.4782 26.7675H81.8184V27.1078H81.4782V26.7675ZM81.4782 27.1078H81.8184V27.448H81.4782V27.1078ZM81.138 27.1078H81.4782V27.448H81.138V27.1078ZM81.4782 27.7882H81.8184V28.1284H81.4782V27.7882ZM81.8184 27.1078H82.1586V27.448H81.8184V27.1078ZM81.8184 27.448H82.1586V27.7882H81.8184V27.448ZM81.8184 27.7882H82.1586V28.1284H81.8184V27.7882ZM81.8184 28.1284H82.1586V28.4686H81.8184V28.1284ZM81.8184 28.4686H82.1586V28.8088H81.8184V28.4686ZM81.8184 28.8088H82.1586V29.149H81.8184V28.8088ZM81.4782 28.8088H81.8184V29.149H81.4782V28.8088ZM81.4782 28.4686H81.8184V28.8088H81.4782V28.4686ZM81.4782 28.1284H81.8184V28.4686H81.4782V28.1284ZM81.4782 27.448H81.8184V27.7882H81.4782V27.448ZM81.138 28.8088H81.4782V29.149H81.138V28.8088ZM81.4782 29.149H81.8184V29.4893H81.4782V29.149ZM81.138 29.149H81.4782V29.4893H81.138V29.149ZM80.7978 29.149H81.138V29.4893H80.7978V29.149ZM80.4575 29.149H80.7978V29.4893H80.4575V29.149ZM80.1173 29.149H80.4575V29.4893H80.1173V29.149ZM80.1173 28.8088H80.4575V29.149H80.1173V28.8088ZM80.4575 28.8088H80.7978V29.149H80.4575V28.8088ZM80.1173 28.4686H80.4575V28.8088H80.1173V28.4686ZM79.7771 28.8088H80.1173V29.149H79.7771V28.8088ZM79.7771 28.4686H80.1173V28.8088H79.7771V28.4686ZM79.7771 28.1284H80.1173V28.4686H79.7771V28.1284ZM79.7771 27.7882H80.1173V28.1284H79.7771V27.7882ZM79.7771 27.448H80.1173V27.7882H79.7771V27.448ZM79.7771 27.1078H80.1173V27.448H79.7771V27.1078ZM80.1173 27.448H80.4575V27.7882H80.1173V27.448ZM80.1173 27.7882H80.4575V28.1284H80.1173V27.7882ZM80.1173 28.1284H80.4575V28.4686H80.1173V28.1284ZM80.7978 28.8088H81.138V29.149H80.7978V28.8088ZM80.7978 27.1078H81.138V27.448H80.7978V27.1078ZM82.4997 27.1078H82.8399V27.448H82.4997V27.1078ZM82.4997 26.7675H82.8399V27.1078H82.4997V26.7675ZM82.8399 26.7675H83.1801V27.1078H82.8399V26.7675ZM82.8399 27.1078H83.1801V27.448H82.8399V27.1078ZM82.8399 27.448H83.1801V27.7882H82.8399V27.448ZM82.8399 27.7882H83.1801V28.1284H82.8399V27.7882ZM82.8399 28.1284H83.1801V28.4686H82.8399V28.1284ZM82.4997 28.1284H82.8399V28.4686H82.4997V28.1284ZM82.4997 27.7882H82.8399V28.1284H82.4997V27.7882ZM82.4997 27.448H82.8399V27.7882H82.4997V27.448ZM82.4997 28.4686H82.8399V28.8088H82.4997V28.4686ZM82.8399 28.4686H83.1801V28.8088H82.8399V28.4686ZM82.8399 28.8088H83.1801V29.149H82.8399V28.8088ZM82.8399 29.149H83.1801V29.4893H82.8399V29.149ZM82.4997 29.149H82.8399V29.4893H82.4997V29.149ZM82.4997 28.8088H82.8399V29.149H82.4997V28.8088ZM83.1801 27.1078H83.5204V27.448H83.1801V27.1078ZM83.5204 27.1078H83.8606V27.448H83.5204V27.1078ZM83.8606 27.1078H84.2008V27.448H83.8606V27.1078ZM83.8606 26.7675H84.2008V27.1078H83.8606V26.7675ZM83.5204 26.7675H83.8606V27.1078H83.5204V26.7675ZM83.1801 27.448H83.5204V27.7882H83.1801V27.448ZM84.2008 27.1078H84.541V27.448H84.2008V27.1078ZM83.8606 27.448H84.2008V27.7882H83.8606V27.448ZM84.8812 27.1078H85.2214V27.448H84.8812V27.1078ZM85.2214 27.448H85.5616V27.7882H85.2214V27.448ZM84.8812 27.448H85.2214V27.7882H84.8812V27.448ZM84.8812 27.7882H85.2214V28.1284H84.8812V27.7882ZM85.2214 27.7882H85.5616V28.1284H85.2214V27.7882ZM85.2214 28.1284H85.5616V28.4686H85.2214V28.1284ZM85.5616 28.1284H85.9019V28.4686H85.5616V28.1284ZM85.9019 28.1284H86.2421V28.4686H85.9019V28.1284ZM86.2421 27.7882H86.5823V28.1284H86.2421V27.7882ZM85.9019 27.7882H86.2421V28.1284H85.9019V27.7882ZM85.5616 27.7882H85.9019V28.1284H85.5616V27.7882ZM86.2421 28.1284H86.5823V28.4686H86.2421V28.1284ZM86.5823 28.1284H86.9225V28.4686H86.5823V28.1284ZM86.5823 28.4686H86.9225V28.8088H86.5823V28.4686ZM86.2421 28.4686H86.5823V28.8088H86.2421V28.4686ZM86.2421 28.8088H86.5823V29.149H86.2421V28.8088ZM86.5823 28.8088H86.9225V29.149H86.5823V28.8088ZM86.2421 29.149H86.5823V29.4893H86.2421V29.149ZM85.9019 28.8088H86.2421V29.149H85.9019V28.8088ZM85.5616 28.8088H85.9019V29.149H85.5616V28.8088ZM85.2214 28.8088H85.5616V29.149H85.2214V28.8088ZM84.8812 28.8088H85.2214V29.149H84.8812V28.8088ZM85.2214 29.149H85.5616V29.4893H85.2214V29.149ZM85.5616 29.149H85.9019V29.4893H85.5616V29.149ZM85.9019 29.149H86.2421V29.4893H85.9019V29.149ZM86.5823 27.1078H86.9225V27.448H86.5823V27.1078ZM86.2421 27.1078H86.5823V27.448H86.2421V27.1078ZM86.2421 26.7675H86.5823V27.1078H86.2421V26.7675ZM85.9019 26.7675H86.2421V27.1078H85.9019V26.7675ZM85.5616 26.7675H85.9019V27.1078H85.5616V26.7675ZM85.2214 26.7675H85.5616V27.1078H85.2214V26.7675ZM85.2214 27.1078H85.5616V27.448H85.2214V27.1078ZM85.5616 27.1078H85.9019V27.448H85.5616V27.1078ZM85.9019 27.1078H86.2421V27.448H85.9019V27.1078Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33594 26.0871H8.67615V26.4273H8.33594V26.0871ZM8.67615 26.0871H9.01637V26.4273H8.67615V26.0871ZM8.67615 26.4273H9.01637V26.7675H8.67615V26.4273ZM8.67615 26.7675H9.01637V27.1078H8.67615V26.7675ZM8.67615 27.1078H9.01637V27.448H8.67615V27.1078ZM8.33594 27.1078H8.67615V27.448H8.33594V27.1078ZM8.33594 26.7675H8.67615V27.1078H8.33594V26.7675ZM8.33594 26.4273H8.67615V26.7675H8.33594V26.4273ZM8.33594 27.448H8.67615V27.7882H8.33594V27.448ZM8.33594 27.7882H8.67615V28.1284H8.33594V27.7882ZM8.33594 28.1284H8.67615V28.4686H8.33594V28.1284ZM8.67615 27.7882H9.01637V28.1284H8.67615V27.7882ZM8.67615 27.448H9.01637V27.7882H8.67615V27.448ZM8.67615 28.1284H9.01637V28.4686H8.67615V28.1284ZM8.67615 28.4686H9.01637V28.8088H8.67615V28.4686ZM8.33594 28.8088H8.67615V29.149H8.33594V28.8088ZM8.33594 28.4686H8.67615V28.8088H8.33594V28.4686ZM8.33594 29.149H8.67615V29.4893H8.33594V29.149ZM8.67615 29.149H9.01637V29.4893H8.67615V29.149ZM8.67615 28.8088H9.01637V29.149H8.67615V28.8088ZM9.01637 26.0871H9.35658V26.4273H9.01637V26.0871ZM9.35658 26.0871H9.6968V26.4273H9.35658V26.0871ZM9.6968 26.0871H10.037V26.4273H9.6968V26.0871ZM10.037 26.0871H10.3772V26.4273H10.037V26.0871ZM9.6968 26.4273H10.037V26.7675H9.6968V26.4273ZM9.35658 26.4273H9.6968V26.7675H9.35658V26.4273ZM9.01637 26.4273H9.35658V26.7675H9.01637V26.4273ZM9.01637 27.7882H9.35658V28.1284H9.01637V27.7882ZM9.35658 27.448H9.6968V27.7882H9.35658V27.448ZM9.01637 27.448H9.35658V27.7882H9.01637V27.448ZM9.35658 27.7882H9.6968V28.1284H9.35658V27.7882ZM10.037 26.4273H10.3772V26.7675H10.037V26.4273ZM9.6968 27.448H10.037V27.7882H9.6968V27.448ZM9.6968 27.7882H10.037V28.1284H9.6968V27.7882ZM10.7174 26.0871H11.3979V26.7675H10.7174V26.0871ZM10.7174 27.1078H11.3979V29.4893H10.7174V27.1078ZM11.7407 26.0871H12.081V26.4273H11.7407V26.0871ZM12.081 26.0871H12.4212V26.4273H12.081V26.0871ZM12.081 26.4273H12.4212V26.7675H12.081V26.4273ZM12.081 26.7675H12.4212V27.1078H12.081V26.7675ZM12.081 27.1078H12.4212V27.448H12.081V27.1078ZM12.081 27.448H12.4212V27.7882H12.081V27.448ZM12.081 27.7882H12.4212V28.1284H12.081V27.7882ZM11.7407 27.7882H12.081V28.1284H11.7407V27.7882ZM11.7407 28.1284H12.081V28.4686H11.7407V28.1284ZM11.7407 28.4686H12.081V28.8088H11.7407V28.4686ZM11.7407 28.8088H12.081V29.149H11.7407V28.8088ZM11.7407 29.149H12.081V29.4893H11.7407V29.149ZM12.081 29.149H12.4212V29.4893H12.081V29.149ZM12.081 28.8088H12.4212V29.149H12.081V28.8088ZM12.081 28.4686H12.4212V28.8088H12.081V28.4686ZM12.081 28.1284H12.4212V28.4686H12.081V28.1284ZM11.7407 27.448H12.081V27.7882H11.7407V27.448ZM11.7407 27.1078H12.081V27.448H11.7407V27.1078ZM11.7407 26.7675H12.081V27.1078H11.7407V26.7675ZM11.7407 26.4273H12.081V26.7675H11.7407V26.4273ZM13.4445 26.7675H13.7847V27.1078H13.4445V26.7675ZM13.1043 26.7675H13.4445V27.1078H13.1043V26.7675ZM13.1043 27.1078H13.4445V27.448H13.1043V27.1078ZM13.4445 27.1078H13.7847V27.448H13.4445V27.1078ZM13.7847 26.7675H14.1249V27.1078H13.7847V26.7675ZM14.1249 26.7675H14.4651V27.1078H14.1249V26.7675ZM14.4651 26.7675H14.8053V27.1078H14.4651V26.7675ZM14.4651 27.1078H14.8053V27.448H14.4651V27.1078ZM14.1249 27.1078H14.4651V27.448H14.1249V27.1078ZM14.8053 27.1078H15.1456V27.448H14.8053V27.1078ZM14.8053 27.448H15.1456V27.7882H14.8053V27.448ZM14.8053 28.8088H15.1456V29.149H14.8053V28.8088ZM14.4651 28.8088H14.8053V29.149H14.4651V28.8088ZM14.4651 27.448H14.8053V27.7882H14.4651V27.448ZM14.1249 28.8088H14.4651V29.149H14.1249V28.8088ZM14.4651 29.149H14.8053V29.4893H14.4651V29.149ZM14.1249 29.149H14.4651V29.4893H14.1249V29.149ZM13.7847 29.149H14.1249V29.4893H13.7847V29.149ZM13.4445 29.149H13.7847V29.4893H13.4445V29.149ZM13.1043 29.149H13.4445V29.4893H13.1043V29.149ZM13.1043 28.8088H13.4445V29.149H13.1043V28.8088ZM13.4445 28.8088H13.7847V29.149H13.4445V28.8088ZM13.1043 28.4686H13.4445V28.8088H13.1043V28.4686ZM12.764 28.8088H13.1043V29.149H12.764V28.8088ZM12.764 28.4686H13.1043V28.8088H12.764V28.4686ZM12.764 28.1284H13.1043V28.4686H12.764V28.1284ZM12.764 27.7882H13.1043V28.1284H12.764V27.7882ZM12.764 27.448H13.1043V27.7882H12.764V27.448ZM12.764 27.1078H13.1043V27.448H12.764V27.1078ZM13.1043 27.448H13.4445V27.7882H13.1043V27.448ZM13.1043 27.7882H13.4445V28.1284H13.1043V27.7882ZM13.1043 28.1284H13.4445V28.4686H13.1043V28.1284ZM13.7847 28.8088H14.1249V29.149H13.7847V28.8088ZM13.7847 27.1078H14.1249V27.448H13.7847V27.1078ZM14.4651 27.7882H14.8053V28.1284H14.4651V27.7882ZM14.8053 27.7882H15.1456V28.1284H14.8053V27.7882ZM13.4445 28.1284H13.7847V28.4686H13.4445V28.1284ZM13.7847 28.1284H14.1249V28.4686H13.7847V28.1284ZM14.1249 28.1284H14.4651V28.4686H14.1249V28.1284ZM14.4651 28.1284H14.8053V28.4686H14.4651V28.1284ZM14.8053 28.1284H15.1456V28.4686H14.8053V28.1284ZM14.1249 27.7882H14.4651V28.1284H14.1249V27.7882ZM13.7847 27.7882H14.1249V28.1284H13.7847V27.7882ZM13.4445 27.7882H13.7847V28.1284H13.4445V27.7882Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0156 26.0871H22.3558V26.4273H22.0156V26.0871ZM22.3558 26.0871H22.6961V26.4273H22.3558V26.0871ZM22.3558 26.4273H22.6961V26.7675H22.3558V26.4273ZM22.3558 26.7675H22.6961V27.1078H22.3558V26.7675ZM22.3558 27.1078H22.6961V27.448H22.3558V27.1078ZM22.0156 27.1078H22.3558V27.448H22.0156V27.1078ZM22.0156 26.7675H22.3558V27.1078H22.0156V26.7675ZM22.0156 26.4273H22.3558V26.7675H22.0156V26.4273ZM22.0156 27.448H22.3558V27.7882H22.0156V27.448ZM22.0156 27.7882H22.3558V28.1284H22.0156V27.7882ZM22.0156 28.1284H22.3558V28.4686H22.0156V28.1284ZM22.3558 27.7882H22.6961V28.1284H22.3558V27.7882ZM22.3558 27.448H22.6961V27.7882H22.3558V27.448ZM22.3558 28.1284H22.6961V28.4686H22.3558V28.1284ZM22.3558 28.4686H22.6961V28.8088H22.3558V28.4686ZM22.0156 28.8088H22.3558V29.149H22.0156V28.8088ZM22.0156 28.4686H22.3558V28.8088H22.0156V28.4686ZM22.0156 29.149H22.3558V29.4893H22.0156V29.149ZM22.3558 29.149H22.6961V29.4893H22.3558V29.149ZM22.3558 28.8088H22.6961V29.149H22.3558V28.8088ZM22.6961 29.149H23.0363V29.4893H22.6961V29.149ZM23.0363 29.149H23.3765V29.4893H23.0363V29.149ZM23.3765 29.149H23.7167V29.4893H23.3765V29.149ZM23.3765 28.8088H23.7167V29.149H23.3765V28.8088ZM23.0363 28.8088H23.3765V29.149H23.0363V28.8088ZM22.6961 28.8088H23.0363V29.149H22.6961V28.8088ZM22.6961 26.0871H23.0363V26.4273H22.6961V26.0871ZM23.0363 26.0871H23.3765V26.4273H23.0363V26.0871ZM23.3765 26.0871H23.7167V26.4273H23.3765V26.0871ZM23.7167 26.0871H24.0569V26.4273H23.7167V26.0871ZM23.3765 26.4273H23.7167V26.7675H23.3765V26.4273ZM23.0363 26.4273H23.3765V26.7675H23.0363V26.4273ZM22.6961 26.4273H23.0363V26.7675H22.6961V26.4273ZM22.6961 27.7882H23.0363V28.1284H22.6961V27.7882ZM23.0363 27.448H23.3765V27.7882H23.0363V27.448ZM22.6961 27.448H23.0363V27.7882H22.6961V27.448ZM23.0363 27.7882H23.3765V28.1284H23.0363V27.7882ZM23.7167 26.4273H24.0569V26.7675H23.7167V26.4273ZM23.7167 28.8088H24.0569V29.149H23.7167V28.8088ZM23.7167 29.149H24.0569V29.4893H23.7167V29.149ZM23.3765 27.448H23.7167V27.7882H23.3765V27.448ZM23.3765 27.7882H23.7167V28.1284H23.3765V27.7882ZM26.7786 27.1078V27.448H26.4384V27.1078H26.7786ZM26.7786 26.7675V27.1078H26.4384V26.7675H26.7786ZM26.4384 26.7675V27.1078H26.0982V26.7675H26.4384ZM26.4384 27.1078V27.448H26.0982V27.1078H26.4384ZM26.4384 27.448V27.7882H26.0982V27.448H26.4384ZM26.4384 27.7882V28.1284H26.0982V27.7882H26.4384ZM26.4384 28.1284V28.4686H26.0982V28.1284H26.4384ZM26.7786 28.1284V28.4686H26.4384V28.1284H26.7786ZM26.7786 27.7882V28.1284H26.4384V27.7882H26.7786ZM26.7786 27.448V27.7882H26.4384V27.448H26.7786ZM26.7786 28.4686V28.8088H26.4384V28.4686H26.7786ZM26.4384 28.4686V28.8088H26.0982V28.4686H26.4384ZM26.4384 28.8088V29.149H26.0982V28.8088H26.4384ZM26.4384 29.149V29.4893H26.0982V29.149H26.4384ZM26.7786 29.149V29.4893H26.4384V29.149H26.7786ZM26.7786 28.8088V29.149H26.4384V28.8088H26.7786ZM25.0776 29.149V29.4893H24.7373V29.149H25.0776ZM24.7373 28.8088V29.149H24.3971V28.8088H24.7373ZM24.7373 28.4686V28.8088H24.3971V28.4686H24.7373ZM24.7373 28.1284V28.4686H24.3971V28.1284H24.7373ZM24.7373 27.7882V28.1284H24.3971V27.7882H24.7373ZM24.7373 27.448V27.7882H24.3971V27.448H24.7373ZM24.7373 27.1078V27.448H24.3971V27.1078H24.7373ZM25.0776 27.7882V28.1284H24.7373V27.7882H25.0776ZM25.0776 28.1284V28.4686H24.7373V28.1284H25.0776ZM25.0776 28.4686V28.8088H24.7373V28.4686H25.0776ZM25.0776 28.8088V29.149H24.7373V28.8088H25.0776ZM25.0776 27.448V27.7882H24.7373V27.448H25.0776ZM25.4178 27.1078V27.448H25.0776V27.1078H25.4178ZM25.4178 26.7675V27.1078H25.0776V26.7675H25.4178ZM25.0776 26.7675V27.1078H24.7373V26.7675H25.0776ZM25.0776 27.1078V27.448H24.7373V27.1078H25.0776ZM25.758 26.7675V27.1078H25.4178V26.7675H25.758ZM26.7786 26.0871V26.4273H26.4384V26.0871H26.7786ZM26.4384 26.0871V26.4273H26.0982V26.0871H26.4384ZM26.4384 26.4273V26.7675H26.0982V26.4273H26.4384ZM26.7786 26.4273V26.7675H26.4384V26.4273H26.7786ZM25.758 29.149V29.4893H25.4178V29.149H25.758ZM25.4178 29.149V29.4893H25.0776V29.149H25.4178ZM25.4178 28.8088V29.149H25.0776V28.8088H25.4178ZM25.758 28.8088V29.149H25.4178V28.8088H25.758ZM26.0982 28.8088V29.149H25.758V28.8088H26.0982ZM26.0982 26.7675V27.1078H25.758V26.7675H26.0982ZM26.0982 27.1078V27.448H25.758V27.1078H26.0982ZM25.758 27.1078V27.448H25.4178V27.1078H25.758ZM27.1197 26.0871H27.8002V26.7675H27.1197V26.0871ZM27.1197 27.1078H27.8002V29.4893H27.1197V27.1078ZM29.5039 28.8088H29.8441V29.149H29.5039V28.8088ZM29.5039 29.149H29.8441V29.4893H29.5039V29.149ZM29.1637 29.149H29.5039V29.4893H29.1637V29.149ZM29.1637 28.8088H29.5039V29.149H29.1637V28.8088ZM28.8235 29.149H29.1637V29.4893H28.8235V29.149ZM28.8235 28.8088H29.1637V29.149H28.8235V28.8088ZM28.4833 28.8088H28.8235V29.149H28.4833V28.8088ZM28.4833 28.4686H28.8235V28.8088H28.4833V28.4686ZM28.4833 28.1284H28.8235V28.4686H28.4833V28.1284ZM28.4833 27.7882H28.8235V28.1284H28.4833V27.7882ZM28.4833 27.448H28.8235V27.7882H28.4833V27.448ZM28.4833 27.1078H28.8235V27.448H28.4833V27.1078ZM28.8235 28.1284H29.1637V28.4686H28.8235V28.1284ZM28.8235 28.4686H29.1637V28.8088H28.8235V28.4686ZM28.8235 27.7882H29.1637V28.1284H28.8235V27.7882ZM28.8235 27.448H29.1637V27.7882H28.8235V27.448ZM28.8235 26.0871H29.1637V26.4273H28.8235V26.0871ZM28.8235 26.4273H29.1637V26.7675H28.8235V26.4273ZM28.8235 26.7675H29.1637V27.1078H28.8235V26.7675ZM28.8235 27.1078H29.1637V27.448H28.8235V27.1078ZM28.4833 26.7675H28.8235V27.1078H28.4833V26.7675ZM28.143 27.1078H28.4833V27.448H28.143V27.1078ZM29.1637 27.1078H29.5039V27.448H29.1637V27.1078ZM29.5039 27.1078H29.8441V27.448H29.5039V27.1078ZM28.4833 26.4273H28.8235V26.7675H28.4833V26.4273ZM28.143 27.448H28.4833V27.7882H28.143V27.448ZM29.1637 27.448H29.5039V27.7882H29.1637V27.448ZM29.5039 27.448H29.8441V27.7882H29.5039V27.448Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8242 26.0871H94.1644V26.4273H93.8242V26.0871ZM94.1644 26.0871H94.5046V26.4273H94.1644V26.0871ZM94.1644 26.4273H94.5046V26.7675H94.1644V26.4273ZM94.1644 26.7675H94.5046V27.1078H94.1644V26.7675ZM94.1644 27.1078H94.5046V27.448H94.1644V27.1078ZM93.8242 26.7675H94.1644V27.1078H93.8242V26.7675ZM93.8242 26.4273H94.1644V26.7675H93.8242V26.4273ZM93.8242 27.1078H94.1644V27.448H93.8242V27.1078ZM93.8242 27.448H94.1644V27.7882H93.8242V27.448ZM93.8242 28.1284H94.1644V28.4686H93.8242V28.1284ZM93.8242 27.7882H94.1644V28.1284H93.8242V27.7882ZM94.1644 27.448H94.5046V27.7882H94.1644V27.448ZM94.1644 27.7882H94.5046V28.1284H94.1644V27.7882ZM94.1644 28.1284H94.5046V28.4686H94.1644V28.1284ZM94.1644 28.4686H94.5046V28.8088H94.1644V28.4686ZM93.8242 28.4686H94.1644V28.8088H93.8242V28.4686ZM93.8242 29.149H94.1644V29.4893H93.8242V29.149ZM94.1644 29.149H94.5046V29.4893H94.1644V29.149ZM94.1644 28.8088H94.5046V29.149H94.1644V28.8088ZM93.8242 28.8088H94.1644V29.149H93.8242V28.8088ZM95.8655 29.149H96.2057V29.4893H95.8655V29.149ZM95.8655 28.8088H96.2057V29.149H95.8655V28.8088ZM95.8655 28.4686H96.2057V28.8088H95.8655V28.4686ZM95.8655 28.1284H96.2057V28.4686H95.8655V28.1284ZM95.8655 27.7882H96.2057V28.1284H95.8655V27.7882ZM95.8655 27.448H96.2057V27.7882H95.8655V27.448ZM95.8655 26.0871H96.2057V26.4273H95.8655V26.0871ZM95.5253 26.0871H95.8655V26.4273H95.5253V26.0871ZM95.5253 26.4273H95.8655V26.7675H95.5253V26.4273ZM95.5253 26.7675H95.8655V27.1078H95.5253V26.7675ZM95.5253 27.1078H95.8655V27.448H95.5253V27.1078ZM95.8655 27.1078H96.2057V27.448H95.8655V27.1078ZM95.8655 26.7675H96.2057V27.1078H95.8655V26.7675ZM95.8655 26.4273H96.2057V26.7675H95.8655V26.4273ZM95.5253 27.448H95.8655V27.7882H95.5253V27.448ZM95.5253 28.8088H95.8655V29.149H95.5253V28.8088ZM95.5253 28.4686H95.8655V28.8088H95.5253V28.4686ZM95.5253 28.1284H95.8655V28.4686H95.5253V28.1284ZM95.5253 27.7882H95.8655V28.1284H95.5253V27.7882ZM95.5253 29.149H95.8655V29.4893H95.5253V29.149ZM95.1851 27.448H95.5253V27.7882H95.1851V27.448ZM94.8449 27.448H95.1851V27.7882H94.8449V27.448ZM94.5046 27.448H94.8449V27.7882H94.5046V27.448ZM94.5046 27.7882H94.8449V28.1284H94.5046V27.7882ZM94.8449 27.7882H95.1851V28.1284H94.8449V27.7882ZM95.1851 27.7882H95.5253V28.1284H95.1851V27.7882ZM97.2273 26.7675H97.5675V27.1078H97.2273V26.7675ZM96.887 26.7675H97.2273V27.1078H96.887V26.7675ZM96.887 27.1078H97.2273V27.448H96.887V27.1078ZM97.2273 27.1078H97.5675V27.448H97.2273V27.1078ZM97.5675 26.7675H97.9077V27.1078H97.5675V26.7675ZM97.9077 26.7675H98.2479V27.1078H97.9077V26.7675ZM98.2479 26.7675H98.5881V27.1078H98.2479V26.7675ZM98.2479 27.1078H98.5881V27.448H98.2479V27.1078ZM97.9077 27.1078H98.2479V27.448H97.9077V27.1078ZM98.5881 27.1078H98.9283V27.448H98.5881V27.1078ZM98.5881 27.448H98.9283V27.7882H98.5881V27.448ZM98.5881 28.8088H98.9283V29.149H98.5881V28.8088ZM98.2479 28.8088H98.5881V29.149H98.2479V28.8088ZM98.2479 27.448H98.5881V27.7882H98.2479V27.448ZM97.9077 28.8088H98.2479V29.149H97.9077V28.8088ZM98.2479 29.149H98.5881V29.4893H98.2479V29.149ZM97.9077 29.149H98.2479V29.4893H97.9077V29.149ZM97.5675 29.149H97.9077V29.4893H97.5675V29.149ZM97.2273 29.149H97.5675V29.4893H97.2273V29.149ZM96.887 29.149H97.2273V29.4893H96.887V29.149ZM96.887 28.8088H97.2273V29.149H96.887V28.8088ZM97.2273 28.8088H97.5675V29.149H97.2273V28.8088ZM96.887 28.4686H97.2273V28.8088H96.887V28.4686ZM96.5468 28.8088H96.887V29.149H96.5468V28.8088ZM96.5468 28.4686H96.887V28.8088H96.5468V28.4686ZM96.5468 28.1284H96.887V28.4686H96.5468V28.1284ZM96.5468 27.7882H96.887V28.1284H96.5468V27.7882ZM96.5468 27.448H96.887V27.7882H96.5468V27.448ZM96.5468 27.1078H96.887V27.448H96.5468V27.1078ZM96.887 27.448H97.2273V27.7882H96.887V27.448ZM96.887 27.7882H97.2273V28.1284H96.887V27.7882ZM96.887 28.1284H97.2273V28.4686H96.887V28.1284ZM97.5675 28.8088H97.9077V29.149H97.5675V28.8088ZM97.5675 27.1078H97.9077V27.448H97.5675V27.1078ZM98.2479 27.7882H98.5881V28.1284H98.2479V27.7882ZM98.5881 27.7882H98.9283V28.1284H98.5881V27.7882ZM97.2273 28.1284H97.5675V28.4686H97.2273V28.1284ZM97.5675 28.1284H97.9077V28.4686H97.5675V28.1284ZM97.9077 28.1284H98.2479V28.4686H97.9077V28.1284ZM98.2479 28.1284H98.5881V28.4686H98.2479V28.1284ZM98.5881 28.1284H98.9283V28.4686H98.5881V28.1284ZM97.9077 27.7882H98.2479V28.1284H97.9077V27.7882ZM97.5675 27.7882H97.9077V28.1284H97.5675V27.7882ZM97.2273 27.7882H97.5675V28.1284H97.2273V27.7882ZM99.2694 26.0871H99.6096V26.4273H99.2694V26.0871ZM99.6096 26.0871H99.9499V26.4273H99.6096V26.0871ZM99.6096 26.4273H99.9499V26.7675H99.6096V26.4273ZM99.6096 26.7675H99.9499V27.1078H99.6096V26.7675ZM99.6096 27.1078H99.9499V27.448H99.6096V27.1078ZM99.6096 27.448H99.9499V27.7882H99.6096V27.448ZM99.6096 27.7882H99.9499V28.1284H99.6096V27.7882ZM99.2694 27.7882H99.6096V28.1284H99.2694V27.7882ZM99.2694 28.1284H99.6096V28.4686H99.2694V28.1284ZM99.2694 28.4686H99.6096V28.8088H99.2694V28.4686ZM99.2694 28.8088H99.6096V29.149H99.2694V28.8088ZM99.2694 29.149H99.6096V29.4893H99.2694V29.149ZM99.6096 29.149H99.9499V29.4893H99.6096V29.149ZM99.6096 28.8088H99.9499V29.149H99.6096V28.8088ZM99.6096 28.4686H99.9499V28.8088H99.6096V28.4686ZM99.6096 28.1284H99.9499V28.4686H99.6096V28.1284ZM99.2694 27.448H99.6096V27.7882H99.2694V27.448ZM99.2694 27.1078H99.6096V27.448H99.2694V27.1078ZM99.2694 26.7675H99.6096V27.1078H99.2694V26.7675ZM99.2694 26.4273H99.6096V26.7675H99.2694V26.4273ZM100.293 27.1078H100.633V27.448H100.293V27.1078ZM100.293 26.7675H100.633V27.1078H100.293V26.7675ZM100.633 26.7675H100.973V27.1078H100.633V26.7675ZM100.633 27.1078H100.973V27.448H100.633V27.1078ZM100.633 27.448H100.973V27.7882H100.633V27.448ZM100.633 27.7882H100.973V28.1284H100.633V27.7882ZM100.633 28.1284H100.973V28.4686H100.633V28.1284ZM100.293 28.1284H100.633V28.4686H100.293V28.1284ZM100.293 27.7882H100.633V28.1284H100.293V27.7882ZM100.293 27.448H100.633V27.7882H100.293V27.448ZM100.293 28.4686H100.633V28.8088H100.293V28.4686ZM100.633 28.4686H100.973V28.8088H100.633V28.4686ZM100.633 28.8088H100.973V29.149H100.633V28.8088ZM100.633 29.149H100.973V29.4893H100.633V29.149ZM100.293 29.149H100.633V29.4893H100.293V29.149ZM100.293 28.8088H100.633V29.149H100.293V28.8088ZM101.994 29.149H102.334V29.4893H101.994V29.149ZM102.334 28.8088H102.674V29.149H102.334V28.8088ZM102.334 28.4686H102.674V28.8088H102.334V28.4686ZM102.334 28.1284H102.674V28.4686H102.334V28.1284ZM102.334 27.7882H102.674V28.1284H102.334V27.7882ZM102.334 27.448H102.674V27.7882H102.334V27.448ZM102.334 27.1078H102.674V27.448H102.334V27.1078ZM101.994 27.7882H102.334V28.1284H101.994V27.7882ZM101.994 28.1284H102.334V28.4686H101.994V28.1284ZM101.994 28.4686H102.334V28.8088H101.994V28.4686ZM101.994 28.8088H102.334V29.149H101.994V28.8088ZM101.994 27.448H102.334V27.7882H101.994V27.448ZM100.973 27.1078H101.313V27.448H100.973V27.1078ZM101.313 27.1078H101.654V27.448H101.313V27.1078ZM101.654 27.1078H101.994V27.448H101.654V27.1078ZM101.654 26.7675H101.994V27.1078H101.654V26.7675ZM101.994 26.7675H102.334V27.1078H101.994V26.7675ZM101.994 27.1078H102.334V27.448H101.994V27.1078ZM101.313 26.7675H101.654V27.1078H101.313V26.7675ZM100.973 29.149H101.313V29.4893H100.973V29.149ZM101.313 29.149H101.654V29.4893H101.313V29.149ZM101.654 29.149H101.994V29.4893H101.654V29.149ZM101.654 28.8088H101.994V29.149H101.654V28.8088ZM101.313 28.8088H101.654V29.149H101.313V28.8088ZM100.973 28.8088H101.313V29.149H100.973V28.8088ZM100.293 29.4893H100.633V29.8295H100.293V29.4893ZM100.633 29.4893H100.973V29.8295H100.633V29.4893ZM100.633 29.8295H100.973V30.1697H100.633V29.8295ZM100.293 29.8295H100.633V30.1697H100.293V29.8295Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2578 29.149H54.598V29.4893H54.2578V29.149ZM54.598 29.149H54.9382V29.4893H54.598V29.149ZM54.598 28.8088H54.9382V29.149H54.598V28.8088ZM54.598 28.4686H54.9382V28.8088H54.598V28.4686ZM54.598 28.1284H54.9382V28.4686H54.598V28.1284ZM54.598 27.7882H54.9382V28.1284H54.598V27.7882ZM54.598 27.448H54.9382V27.7882H54.598V27.448ZM54.2578 27.448H54.598V27.7882H54.2578V27.448ZM54.2578 27.7882H54.598V28.1284H54.2578V27.7882ZM54.2578 28.1284H54.598V28.4686H54.2578V28.1284ZM54.2578 28.4686H54.598V28.8088H54.2578V28.4686ZM54.2578 28.8088H54.598V29.149H54.2578V28.8088ZM54.2578 27.1078H54.598V27.448H54.2578V27.1078ZM54.598 27.1078H54.9382V27.448H54.598V27.1078ZM54.598 26.7675H54.9382V27.1078H54.598V26.7675ZM54.598 26.4273H54.9382V26.7675H54.598V26.4273ZM54.598 26.0871H54.9382V26.4273H54.598V26.0871ZM54.2578 26.0871H54.598V26.4273H54.2578V26.0871ZM54.2578 26.4273H54.598V26.7675H54.2578V26.4273ZM54.2578 26.7675H54.598V27.1078H54.2578V26.7675ZM55.2811 27.1078H55.6213V27.448H55.2811V27.1078ZM55.2811 26.7675H55.6213V27.1078H55.2811V26.7675ZM55.6213 26.7675H55.9615V27.1078H55.6213V26.7675ZM55.6213 27.1078H55.9615V27.448H55.6213V27.1078ZM55.6213 27.448H55.9615V27.7882H55.6213V27.448ZM55.6213 27.7882H55.9615V28.1284H55.6213V27.7882ZM55.6213 28.1284H55.9615V28.4686H55.6213V28.1284ZM55.2811 28.1284H55.6213V28.4686H55.2811V28.1284ZM55.2811 27.7882H55.6213V28.1284H55.2811V27.7882ZM55.2811 27.448H55.6213V27.7882H55.2811V27.448ZM55.2811 28.4686H55.6213V28.8088H55.2811V28.4686ZM55.6213 28.4686H55.9615V28.8088H55.6213V28.4686ZM55.6213 28.8088H55.9615V29.149H55.6213V28.8088ZM55.6213 29.149H55.9615V29.4893H55.6213V29.149ZM55.2811 29.149H55.6213V29.4893H55.2811V29.149ZM55.2811 28.8088H55.6213V29.149H55.2811V28.8088ZM56.642 29.149H56.9822V29.4893H56.642V29.149ZM56.9822 29.149H57.3224V29.4893H56.9822V29.149ZM56.9822 28.8088H57.3224V29.149H56.9822V28.8088ZM56.9822 28.4686H57.3224V28.8088H56.9822V28.4686ZM56.9822 28.1284H57.3224V28.4686H56.9822V28.1284ZM56.9822 27.7882H57.3224V28.1284H56.9822V27.7882ZM56.9822 27.448H57.3224V27.7882H56.9822V27.448ZM56.9822 27.1078H57.3224V27.448H56.9822V27.1078ZM56.642 27.7882H56.9822V28.1284H56.642V27.7882ZM56.642 28.1284H56.9822V28.4686H56.642V28.1284ZM56.642 28.4686H56.9822V28.8088H56.642V28.4686ZM56.642 28.8088H56.9822V29.149H56.642V28.8088ZM56.642 27.448H56.9822V27.7882H56.642V27.448ZM55.9615 27.1078H56.3018V27.448H55.9615V27.1078ZM56.3018 27.1078H56.642V27.448H56.3018V27.1078ZM56.642 26.7675H56.9822V27.1078H56.642V26.7675ZM56.642 27.1078H56.9822V27.448H56.642V27.1078ZM56.3018 26.7675H56.642V27.1078H56.3018V26.7675ZM58.0028 29.149H58.343V29.4893H58.0028V29.149ZM58.343 29.149H58.6833V29.4893H58.343V29.149ZM58.343 28.8088H58.6833V29.149H58.343V28.8088ZM58.343 28.4686H58.6833V28.8088H58.343V28.4686ZM58.343 28.1284H58.6833V28.4686H58.343V28.1284ZM58.343 27.7882H58.6833V28.1284H58.343V27.7882ZM58.343 27.448H58.6833V27.7882H58.343V27.448ZM58.343 27.1078H58.6833V27.448H58.343V27.1078ZM58.0028 27.7882H58.343V28.1284H58.0028V27.7882ZM58.0028 28.1284H58.343V28.4686H58.0028V28.1284ZM58.0028 28.4686H58.343V28.8088H58.0028V28.4686ZM58.0028 28.8088H58.343V29.149H58.0028V28.8088ZM58.0028 27.448H58.343V27.7882H58.0028V27.448ZM57.3224 27.1078H57.6626V27.448H57.3224V27.1078ZM57.6626 27.1078H58.0028V27.448H57.6626V27.1078ZM58.0028 26.7675H58.343V27.1078H58.0028V26.7675ZM58.0028 27.1078H58.343V27.448H58.0028V27.1078ZM57.6626 26.7675H58.0028V27.1078H57.6626V26.7675ZM61.0621 29.4893H60.7219V29.149H61.0621V29.4893ZM61.0621 29.149H60.7219V28.8088H61.0621V29.149ZM60.7219 29.149H60.3817V28.8088H60.7219V29.149ZM60.3817 29.4893H60.0415V29.149H60.3817V29.4893ZM60.0415 29.4893H59.7013V29.149H60.0415V29.4893ZM59.7013 29.4893H59.361V29.149H59.7013V29.4893ZM59.7013 29.149H59.361V28.8088H59.7013V29.149ZM60.0415 29.149H59.7013V28.8088H60.0415V29.149ZM59.361 29.149H59.0208V28.8088H59.361V29.149ZM59.361 28.8088H59.0208V28.4686H59.361V28.8088ZM59.361 27.448H59.0208V27.1078H59.361V27.448ZM59.7013 27.448H59.361V27.1078H59.7013V27.448ZM59.7013 28.8088H59.361V28.4686H59.7013V28.8088ZM60.0415 27.448H59.7013V27.1078H60.0415V27.448ZM59.7013 27.1078H59.361V26.7675H59.7013V27.1078ZM60.0415 27.1078H59.7013V26.7675H60.0415V27.1078ZM60.3817 27.1078H60.0415V26.7675H60.3817V27.1078ZM60.7219 27.1078H60.3817V26.7675H60.7219V27.1078ZM61.0621 27.1078H60.7219V26.7675H61.0621V27.1078ZM61.0621 27.448H60.7219V27.1078H61.0621V27.448ZM60.7219 27.448H60.3817V27.1078H60.7219V27.448ZM61.0621 27.7882H60.7219V27.448H61.0621V27.7882ZM61.4023 27.448H61.0621V27.1078H61.4023V27.448ZM61.4023 27.7882H61.0621V27.448H61.4023V27.7882ZM61.4023 28.1284H61.0621V27.7882H61.4023V28.1284ZM61.4023 28.4686H61.0621V28.1284H61.4023V28.4686ZM61.4023 28.8088H61.0621V28.4686H61.4023V28.8088ZM61.4023 29.149H61.0621V28.8088H61.4023V29.149ZM61.0621 28.8088H60.7219V28.4686H61.0621V28.8088ZM61.0621 28.4686H60.7219V28.1284H61.0621V28.4686ZM61.0621 28.1284H60.7219V27.7882H61.0621V28.1284ZM60.3817 27.448H60.0415V27.1078H60.3817V27.448ZM60.3817 29.149H60.0415V28.8088H60.3817V29.149ZM61.0621 29.149H61.4023V29.4893H61.0621V29.149ZM60.3817 27.7882H60.7219V28.1284H60.3817V27.7882ZM60.0415 27.7882H60.3817V28.1284H60.0415V27.7882ZM59.7013 27.7882H60.0415V28.1284H59.7013V27.7882ZM59.361 27.7882H59.7013V28.1284H59.361V27.7882ZM59.0208 28.1284H59.361V28.4686H59.0208V28.1284ZM59.361 28.1284H59.7013V28.4686H59.361V28.1284ZM60.3817 28.1284H60.7219V28.4686H60.3817V28.1284ZM60.0415 28.1284H60.3817V28.4686H60.0415V28.1284ZM59.7013 28.1284H60.0415V28.4686H59.7013V28.1284ZM63.7847 26.7675H64.1249V27.1078H63.7847V26.7675ZM63.4445 26.7675H63.7847V27.1078H63.4445V26.7675ZM63.1043 26.7675H63.4445V27.1078H63.1043V26.7675ZM62.7641 26.7675H63.1043V27.1078H62.7641V26.7675ZM62.4239 26.7675H62.7641V27.1078H62.4239V26.7675ZM62.4239 27.1078H62.7641V27.448H62.4239V27.1078ZM62.7641 27.1078H63.1043V27.448H62.7641V27.1078ZM63.1043 27.1078H63.4445V27.448H63.1043V27.1078ZM63.4445 27.1078H63.7847V27.448H63.4445V27.1078ZM63.7847 27.1078H64.1249V27.448H63.7847V27.1078ZM62.0836 26.7675H62.4239V27.1078H62.0836V26.7675ZM62.0836 27.1078H62.4239V27.448H62.0836V27.1078ZM62.0836 27.448H62.4239V27.7882H62.0836V27.448ZM61.7434 27.448H62.0836V27.7882H61.7434V27.448ZM61.7434 27.1078H62.0836V27.448H61.7434V27.1078ZM61.7434 27.7882H62.0836V28.1284H61.7434V27.7882ZM61.7434 28.1284H62.0836V28.4686H61.7434V28.1284ZM62.0836 28.4686H62.4239V28.8088H62.0836V28.4686ZM62.0836 28.1284H62.4239V28.4686H62.0836V28.1284ZM62.0836 27.7882H62.4239V28.1284H62.0836V27.7882ZM61.7434 28.4686H62.0836V28.8088H61.7434V28.4686ZM62.0836 28.8088H62.4239V29.149H62.0836V28.8088ZM62.4239 28.8088H62.7641V29.149H62.4239V28.8088ZM62.7641 28.8088H63.1043V29.149H62.7641V28.8088ZM63.4445 28.8088H63.7847V29.149H63.4445V28.8088ZM63.7847 28.8088H64.1249V29.149H63.7847V28.8088ZM63.7847 28.4686H64.1249V28.8088H63.7847V28.4686ZM63.4445 28.4686H63.7847V28.8088H63.4445V28.4686ZM63.1043 28.4686H63.4445V28.8088H63.1043V28.4686ZM62.7641 28.4686H63.1043V28.8088H62.7641V28.4686ZM62.4239 28.4686H62.7641V28.8088H62.4239V28.4686ZM63.4445 28.1284H63.7847V28.4686H63.4445V28.1284ZM63.4445 27.7882H63.7847V28.1284H63.4445V27.7882ZM63.4445 27.448H63.7847V27.7882H63.4445V27.448ZM63.7847 27.448H64.1249V27.7882H63.7847V27.448ZM63.7847 27.7882H64.1249V28.1284H63.7847V27.7882ZM63.7847 28.1284H64.1249V28.4686H63.7847V28.1284ZM63.4445 29.149H63.7847V29.4893H63.4445V29.149ZM63.4445 29.4893H63.7847V29.8295H63.4445V29.4893ZM63.7847 29.4893H64.1249V29.8295H63.7847V29.4893ZM63.7847 29.149H64.1249V29.4893H63.7847V29.149ZM61.7434 29.4893H62.0836V29.8295H61.7434V29.4893ZM62.0836 29.4893H62.4239V29.8295H62.0836V29.4893ZM62.0836 29.8295H62.4239V30.1697H62.0836V29.8295ZM62.4239 29.8295H62.7641V30.1697H62.4239V29.8295ZM62.4239 29.4893H62.7641V29.8295H62.4239V29.4893ZM62.7641 29.4893H63.1043V29.8295H62.7641V29.4893ZM63.1043 29.4893H63.4445V29.8295H63.1043V29.4893ZM63.4445 29.8295H63.7847V30.1697H63.4445V29.8295ZM63.1043 29.8295H63.4445V30.1697H63.1043V29.8295ZM62.7641 29.8295H63.1043V30.1697H62.7641V29.8295ZM65.1465 26.7675H65.4867V27.1078H65.1465V26.7675ZM64.8062 26.7675H65.1465V27.1078H64.8062V26.7675ZM64.8062 27.1078H65.1465V27.448H64.8062V27.1078ZM65.1465 27.1078H65.4867V27.448H65.1465V27.1078ZM65.4867 26.7675H65.8269V27.1078H65.4867V26.7675ZM65.8269 26.7675H66.1671V27.1078H65.8269V26.7675ZM66.1671 26.7675H66.5073V27.1078H66.1671V26.7675ZM66.1671 27.1078H66.5073V27.448H66.1671V27.1078ZM65.8269 27.1078H66.1671V27.448H65.8269V27.1078ZM66.5073 27.1078H66.8475V27.448H66.5073V27.1078ZM66.5073 27.448H66.8475V27.7882H66.5073V27.448ZM66.5073 28.8088H66.8475V29.149H66.5073V28.8088ZM66.1671 28.8088H66.5073V29.149H66.1671V28.8088ZM66.1671 27.448H66.5073V27.7882H66.1671V27.448ZM65.8269 28.8088H66.1671V29.149H65.8269V28.8088ZM66.1671 29.149H66.5073V29.4893H66.1671V29.149ZM65.8269 29.149H66.1671V29.4893H65.8269V29.149ZM65.4867 29.149H65.8269V29.4893H65.4867V29.149ZM65.1465 29.149H65.4867V29.4893H65.1465V29.149ZM64.8062 29.149H65.1465V29.4893H64.8062V29.149ZM64.8062 28.8088H65.1465V29.149H64.8062V28.8088ZM65.1465 28.8088H65.4867V29.149H65.1465V28.8088ZM64.8062 28.4686H65.1465V28.8088H64.8062V28.4686ZM64.466 28.8088H64.8062V29.149H64.466V28.8088ZM64.466 28.4686H64.8062V28.8088H64.466V28.4686ZM64.466 28.1284H64.8062V28.4686H64.466V28.1284ZM64.466 27.7882H64.8062V28.1284H64.466V27.7882ZM64.466 27.448H64.8062V27.7882H64.466V27.448ZM64.466 27.1078H64.8062V27.448H64.466V27.1078ZM64.8062 27.448H65.1465V27.7882H64.8062V27.448ZM64.8062 27.7882H65.1465V28.1284H64.8062V27.7882ZM64.8062 28.1284H65.1465V28.4686H64.8062V28.1284ZM65.4867 28.8088H65.8269V29.149H65.4867V28.8088ZM65.4867 27.1078H65.8269V27.448H65.4867V27.1078ZM66.1671 27.7882H66.5073V28.1284H66.1671V27.7882ZM66.5073 27.7882H66.8475V28.1284H66.5073V27.7882ZM65.1465 28.1284H65.4867V28.4686H65.1465V28.1284ZM65.4867 28.1284H65.8269V28.4686H65.4867V28.1284ZM65.8269 28.1284H66.1671V28.4686H65.8269V28.1284ZM66.1671 28.1284H66.5073V28.4686H66.1671V28.1284ZM66.5073 28.1284H66.8475V28.4686H66.5073V28.1284ZM65.8269 27.7882H66.1671V28.1284H65.8269V27.7882ZM65.4867 27.7882H65.8269V28.1284H65.4867V27.7882ZM65.1465 27.7882H65.4867V28.1284H65.1465V27.7882Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6562,
    y: 5.8623,
    width: 4.88514,
    height: 0.977027,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7562 2.93164H91.8711V6.83975H96.7562V2.93164ZM95.7771 3.9085H92.846V5.86255H95.7771V3.9085Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8711 2.93164V2.68738H91.6268V2.93164H91.8711ZM96.7562 2.93164H97.0005V2.68738H96.7562V2.93164ZM91.8711 6.83975H91.6268V7.08401H91.8711V6.83975ZM96.7562 6.83975V7.08401H97.0005V6.83975H96.7562ZM92.846 3.9085V3.66424H92.6018V3.9085H92.846ZM95.7771 3.9085H96.0214V3.66424H95.7771V3.9085ZM92.846 5.86255H92.6018V6.10681H92.846V5.86255ZM95.7771 5.86255V6.10681H96.0214V5.86255H95.7771ZM91.8711 3.1759H96.7562V2.68738H91.8711V3.1759ZM92.1154 6.83975V2.93164H91.6268V6.83975H92.1154ZM96.7562 6.59549H91.8711V7.08401H96.7562V6.59549ZM96.512 2.93164V6.83975H97.0005V2.93164H96.512ZM92.846 4.15275H95.7771V3.66424H92.846V4.15275ZM93.0903 5.86255V3.9085H92.6018V5.86255H93.0903ZM95.7771 5.61829H92.846V6.10681H95.7771V5.61829ZM95.5329 3.9085V5.86255H96.0214V3.9085H95.5329Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.021 5.68881L110.634 7.06844L109.945 6.37573L111.329 4.99979L109.945 3.62385L110.634 2.93114L112.021 4.31077L113.409 2.93066L114.098 3.62337L112.714 4.99979L114.098 6.37621L113.409 7.06891L112.021 5.68881Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.634 7.06844L110.461 7.24069L110.633 7.41387L110.807 7.24162L110.634 7.06844ZM112.021 5.68881L112.194 5.51564L112.021 5.3443L111.849 5.51564L112.021 5.68881ZM109.945 6.37573L109.773 6.20256L109.6 6.37481L109.772 6.54799L109.945 6.37573ZM111.329 4.99979L111.501 5.17297L111.675 4.99979L111.501 4.82661L111.329 4.99979ZM109.945 3.62385L109.772 3.45159L109.6 3.62477L109.773 3.79702L109.945 3.62385ZM110.634 2.93114L110.807 2.75796L110.633 2.58571L110.461 2.75889L110.634 2.93114ZM112.021 4.31077L111.849 4.48394L112.021 4.65528L112.194 4.48394L112.021 4.31077ZM113.409 2.93066L113.582 2.75841L113.41 2.58523L113.237 2.75749L113.409 2.93066ZM114.098 3.62337L114.27 3.79655L114.443 3.62429L114.271 3.45112L114.098 3.62337ZM112.714 4.99979L112.542 4.82661L112.368 4.99979L112.542 5.17297L112.714 4.99979ZM114.098 6.37621L114.271 6.54846L114.443 6.37528L114.27 6.20303L114.098 6.37621ZM113.409 7.06891L113.237 7.24209L113.41 7.41434L113.582 7.24117L113.409 7.06891ZM110.807 7.24162L112.194 5.86199L111.849 5.51564L110.462 6.89526L110.807 7.24162ZM109.772 6.54799L110.461 7.24069L110.808 6.89619L110.118 6.20348L109.772 6.54799ZM111.156 4.82661L109.773 6.20256L110.118 6.54891L111.501 5.17297L111.156 4.82661ZM111.501 4.82661L110.118 3.45067L109.773 3.79702L111.156 5.17297L111.501 4.82661ZM110.118 3.7961L110.808 3.10339L110.461 2.75889L109.772 3.45159L110.118 3.7961ZM110.462 3.10432L111.849 4.48394L112.194 4.13759L110.807 2.75796L110.462 3.10432ZM113.237 2.75749L111.849 4.13759L112.194 4.48394L113.581 3.10384L113.237 2.75749ZM114.271 3.45112L113.582 2.75841L113.236 3.10292L113.925 3.79562L114.271 3.45112ZM112.886 5.17297L114.27 3.79655L113.926 3.45019L112.542 4.82661L112.886 5.17297ZM112.542 5.17297L113.926 6.54938L114.27 6.20303L112.886 4.82661L112.542 5.17297ZM113.925 6.20395L113.236 6.89666L113.582 7.24117L114.271 6.54846L113.925 6.20395ZM113.581 6.89574L112.194 5.51564L111.849 5.86199L113.237 7.24209L113.581 6.89574Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.561,
    y: 38.9015,
    width: 5.86216,
    height: 4.88514,
    stroke: "black",
    strokeWidth: 0.488514,
    strokeDasharray: "0.98 0.98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.441 40.0312L107.97 39.1152L108.181 39.2373L108.234 39.1457L108.287 39.2373L108.499 39.1152L109.027 40.0312L108.816 40.1533L109.345 41.0693L109.556 40.9471L110.085 41.8631L109.874 41.9852L110.402 42.9012L110.614 42.7791L111.143 43.695L110.931 43.8172L110.984 43.9087H110.878V44.153H109.821V43.9087H108.763V44.153H107.705V43.9087H106.648V44.153H105.59V43.9087H105.484L105.537 43.8172L105.326 43.695L105.854 42.7791L106.066 42.9012L106.595 41.9852L106.383 41.8631L106.912 40.9471L107.124 41.0693L107.652 40.1533L107.441 40.0312Z",
    stroke: "black",
    strokeWidth: 0.488514,
    strokeDasharray: "0.98 0.98"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118.154,
    y: 54.7523,
    width: 0.888107,
    height: 2.42415,
    rx: 0.244257,
    transform: "rotate(-36 118.154 54.7523)",
    fill: "#6B65C7",
    stroke: "black",
    strokeWidth: 0.488514
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.401,
    cy: 52.9607,
    r: 1.95306,
    transform: "rotate(-36 117.401 52.9607)",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.551 52.2683C110.88 52.0378 111.343 52.1216 111.576 52.4554C111.81 52.7892 111.731 53.2526 111.401 53.4831L106.932 56.6127C106.802 56.7039 106.641 56.7506 106.481 56.7446C105.996 56.7262 105.654 56.2385 105.803 55.7765C105.852 55.6236 105.951 55.4891 106.081 55.3979L110.551 52.2683Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 109.133,
    y: 52.3301,
    width: 3.0038,
    height: 0.747395,
    rx: 0.373697,
    transform: "rotate(55 109.133 52.3301)",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.211,
    y: 51.5088,
    width: 1.97153,
    height: 2.91836,
    rx: 0.985764,
    transform: "rotate(55 111.211 51.5088)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.529,
    y: 66.6583,
    width: 3.63323,
    height: 2.52871,
    rx: 0.244257,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 116.285,
    y: 66.4141,
    width: 4.12174,
    height: 0.862064,
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-2_1596_3872",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.229 62.592C119.229 62.3222 119.01 62.1035 118.741 62.1035H117.951C117.681 62.1035 117.463 62.3222 117.463 62.592V64.9336C117.463 65.2034 117.244 65.4221 116.974 65.4221H116.774C116.504 65.4221 116.285 65.6409 116.285 65.9107V66.356C116.285 66.6258 116.504 66.8446 116.774 66.8446H119.918C120.188 66.8446 120.407 66.6258 120.407 66.356V65.9107C120.407 65.6409 120.188 65.4221 119.918 65.4221H119.718C119.448 65.4221 119.229 65.2034 119.229 64.9336V62.592Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.229 62.592C119.229 62.3222 119.01 62.1035 118.741 62.1035H117.951C117.681 62.1035 117.463 62.3222 117.463 62.592V64.9336C117.463 65.2034 117.244 65.4221 116.974 65.4221H116.774C116.504 65.4221 116.285 65.6409 116.285 65.9107V66.356C116.285 66.6258 116.504 66.8446 116.774 66.8446H119.918C120.188 66.8446 120.407 66.6258 120.407 66.356V65.9107C120.407 65.6409 120.188 65.4221 119.918 65.4221H119.718C119.448 65.4221 119.229 65.2034 119.229 64.9336V62.592Z",
    fill: "#B5C65F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.951 62.592H118.741V61.615H117.951V62.592ZM117.951 64.9336V62.592H116.974V64.9336H117.951ZM116.774 65.9107H116.974V64.9336H116.774V65.9107ZM116.774 66.356V65.9107H115.797V66.356H116.774ZM119.918 66.356H116.774V67.3331H119.918V66.356ZM119.918 65.9107V66.356H120.895V65.9107H119.918ZM119.718 65.9107H119.918V64.9336H119.718V65.9107ZM118.741 62.592V64.9336H119.718V62.592H118.741ZM119.718 64.9336H118.741C118.741 65.4732 119.178 65.9107 119.718 65.9107V64.9336ZM120.895 65.9107C120.895 65.3711 120.458 64.9336 119.918 64.9336V65.9107H119.918H120.895ZM119.918 67.3331C120.458 67.3331 120.895 66.8956 120.895 66.356H119.918V67.3331ZM115.797 66.356C115.797 66.8956 116.234 67.3331 116.774 67.3331V66.356H116.774H115.797ZM116.774 64.9336C116.234 64.9336 115.797 65.3711 115.797 65.9107H116.774L116.774 65.9107V64.9336ZM116.974 64.9336H116.974V65.9107C117.514 65.9107 117.951 65.4732 117.951 64.9336H116.974ZM118.741 62.592L118.741 62.592H119.718C119.718 62.0524 119.28 61.615 118.741 61.615V62.592ZM117.951 61.615C117.412 61.615 116.974 62.0524 116.974 62.592H117.951V62.592V61.615Z",
    fill: "black",
    mask: "url(#path-63-inside-2_1596_3872)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118.889,
    y1: 67.7939,
    x2: 118.889,
    y2: 69.3457,
    stroke: "black",
    strokeWidth: 0.488514
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 117.709,
    y1: 67.7939,
    x2: 117.709,
    y2: 69.3457,
    stroke: "black",
    strokeWidth: 0.488514
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.428 62.1614C109.496 62.0446 109.645 62.0046 109.762 62.072L110.806 62.6751C110.923 62.7426 110.963 62.8919 110.896 63.0088L107.855 68.2755C107.826 68.3253 107.781 68.3634 107.727 68.383L107.097 68.6113L106.573 68.8013L106.476 68.2524L106.359 67.5929C106.348 67.5363 106.359 67.4779 106.387 67.4281L109.428 62.1614Z",
    fill: "#FFE7C2",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.428 62.1614C109.496 62.0446 109.645 62.0046 109.762 62.072L110.806 62.6751C110.923 62.7426 110.963 62.8919 110.896 63.0088L110.533 63.6373L109.065 62.7899L109.428 62.1614Z",
    fill: "#FF7B3F",
    stroke: "black",
    strokeWidth: 0.488514
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 108.691,
    y: 63.443,
    width: 1.69473,
    height: 4.1091,
    transform: "rotate(30 108.691 63.443)",
    fill: "#FCC572",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.14 85.0635C118.62 85.2453 119.04 85.7481 119.159 86.2007C119.24 86.5072 119.261 86.8684 119.18 87.1766C119.064 87.615 118.668 87.9417 118.385 88.2914C117.95 88.8286 117.527 89.5912 117.924 90.2394C118.136 90.584 118.44 90.9027 118.731 91.1927C118.81 91.2714 118.922 91.329 118.984 91.4142",
    stroke: "black",
    strokeWidth: 0.488514,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 106.223,
    y1: 85.4433,
    x2: 111.23,
    y2: 91.2023,
    stroke: "black",
    strokeWidth: 0.488514
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.164 74.4226H118.587H118.594C118.656 74.4461 118.691 74.472 118.7 74.5002L120.394 78.7975L120.408 78.8328H120.789H121.163V79.0868V79.3408H121.078L120.471 79.3267C120.128 79.322 119.756 79.322 119.357 79.3267L118.672 79.3408H118.58V79.0868V78.8328H118.884L119.187 78.8257L119.06 78.5082L118.933 78.1906H118.065C117.487 78.1906 117.197 78.193 117.197 78.1977L117.07 78.5152L116.95 78.8257C116.95 78.8304 117.051 78.8328 117.254 78.8328H117.55V79.0868V79.3408H117.48L116.957 79.3267C116.652 79.322 116.369 79.322 116.111 79.3267L115.666 79.3408H115.603V79.0868V78.8328H115.977H116.358L116.372 78.7975L118.065 74.5002C118.079 74.4767 118.112 74.4508 118.164 74.4226ZM118.404 76.8358L118.072 75.9891H118.065L117.402 77.6826H118.072L118.736 77.6755L118.404 76.8358Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.386 75.1729C107.141 75.1209 106.959 75.0826 106.717 75.1769C106.428 75.2892 106.287 75.4366 106.119 75.6807C105.918 75.9746 105.784 76.2784 105.657 76.61C105.588 76.7923 105.541 77.0112 105.501 77.2033C105.479 77.3063 105.457 77.4093 105.435 77.5123C105.4 77.6762 105.398 77.6098 105.445 77.4865C105.574 77.1409 105.89 76.8133 106.134 76.5442C106.36 76.2949 106.625 75.9746 106.935 75.8289C107.135 75.7347 107.26 75.6026 107.423 75.4691C107.496 75.409 107.299 75.421 107.271 75.4269C106.999 75.4833 106.741 75.6523 106.533 75.8299C106.264 76.06 105.958 76.3033 105.739 76.5813C105.711 76.6168 105.627 76.7198 105.644 76.6782C105.719 76.5015 105.87 76.3492 105.996 76.2086C106.246 75.9301 106.516 75.8025 106.861 75.6656C107.006 75.6077 107.143 75.5273 107.294 75.4849C107.401 75.4551 107.499 75.5078 107.595 75.4874C107.692 75.4668 107.513 75.3846 107.479 75.3696C107.344 75.3105 107.192 75.2984 107.067 75.2193C106.858 75.0878 106.527 75.1882 106.309 75.2323C105.952 75.3048 105.58 75.4717 105.338 75.7541C105.137 75.989 105.106 76.3466 105.044 76.6384C105.017 76.7648 104.907 77.2045 105.015 77.3005C105.03 77.3141 105.024 77.3214 105.032 77.2874C105.067 77.1193 105.095 76.9467 105.15 76.7834C105.252 76.4782 105.438 76.2181 105.613 75.9532C105.67 75.8669 105.724 75.7396 105.818 75.6861C105.841 75.6728 105.798 75.7366 105.785 75.76C105.68 75.9465 105.564 76.1242 105.479 76.3215C105.351 76.6201 105.276 76.9613 105.209 77.2791C105.156 77.5301 105.164 77.7406 105.182 77.9933C105.196 78.1797 105.224 78.3866 105.185 78.5703C105.174 78.624 105.255 78.3831 105.274 78.344C105.331 78.2214 105.402 78.1368 105.431 78.0016C105.502 77.6686 105.667 77.3474 105.844 77.0618C106.006 76.7999 106.22 76.5792 106.442 76.366C106.642 76.1728 106.881 76.0264 107.084 75.8341C107.231 75.6949 107.424 75.6317 107.578 75.5019C107.636 75.4526 107.713 75.4292 107.786 75.4139C107.848 75.4008 107.946 75.4425 108.008 75.4555C108.219 75.5003 107.967 75.5339 107.887 75.4661C107.822 75.4107 107.781 75.3021 107.704 75.267C107.623 75.2302 107.548 75.2074 107.458 75.1882",
    stroke: "#625FA4",
    strokeWidth: 0.488514,
    strokeLinecap: "square"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 107.663,
    y: 77.0309,
    width: 2.44257,
    height: 3.4196,
    rx: 0.488514,
    transform: "rotate(-27.1655 107.663 77.0309)",
    fill: "#16077C",
    stroke: "black",
    strokeWidth: 0.488514,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.294 75.165C108.225 75.1327 108.145 75.134 108.078 75.1686C108.011 75.2033 107.963 75.2672 107.949 75.3418L107.698 76.706C107.682 76.7975 107.718 76.8907 107.793 76.9462C107.868 77.0017 107.967 77.01 108.05 76.9675L109.556 76.1949C109.639 76.1524 109.69 76.0665 109.688 75.9735C109.687 75.8804 109.633 75.7963 109.548 75.7566L108.294 75.165Z",
    fill: "#DFE5FF",
    stroke: "black",
    strokeWidth: 0.488514,
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 105.303,
    y: 97.0323,
    width: 6.35068,
    height: 4.88514,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.584 101.568L115.417 101.917H115.805H121.178H121.423V101.673V99.8218V99.5775H121.178H119.456L120.466 97.3782L120.625 97.0321H120.244H117.907H117.753L117.687 97.171L115.584 101.568Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.654 111.2C111.654 112.498 110.29 113.643 108.478 113.643C106.666 113.643 105.303 112.498 105.303 111.2C105.303 109.903 106.666 108.758 108.478 108.758C110.29 108.758 111.654 109.903 111.654 111.2Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 115.072,
    y: 108.758,
    width: 6.35068,
    height: 4.88514,
    rx: 1.22128,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.488514
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1596_3872",
    x: 4.9136,
    y: 22.5342,
    width: 120.466,
    height: 11.5287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.488514,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.46554,
    dy: 1.7098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.977027
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1596_3872",
    x: 74.7691,
    y: 0,
    width: 14.4618,
    height: 10.0638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.488514,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.46554,
    dy: 1.7098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.977027
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1596_3872",
    x: 86.9839,
    y: 0,
    width: 14.4618,
    height: 10.0638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.488514,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.46554,
    dy: 1.7098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.977027
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_1596_3872",
    x: 99.1948,
    y: -0.977027,
    width: 25.6961,
    height: 11.0409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.488514,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.46554,
    dy: 1.7098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.635068
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.977027,
    dy: -0.977027
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683919
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_1596_3872",
    x: 8.48226,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii_1596_3872",
    x: 23.5604,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dii_1596_3872",
    x: 16.0174,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dii_1596_3872",
    x: 31.0994,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dii_1596_3872",
    x: 8.48226,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dii_1596_3872",
    x: 23.5604,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dii_1596_3872",
    x: 16.0174,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dii_1596_3872",
    x: 31.0994,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dii_1596_3872",
    x: 38.6463,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dii_1596_3872",
    x: 53.7323,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_dii_1596_3872",
    x: 46.1815,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dii_1596_3872",
    x: 61.2674,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_dii_1596_3872",
    x: 38.6463,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dii_1596_3872",
    x: 53.7323,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_dii_1596_3872",
    x: 46.1815,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_dii_1596_3872",
    x: 61.2674,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_dii_1596_3872",
    x: 68.8104,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_dii_1596_3872",
    x: 83.8963,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_dii_1596_3872",
    x: 76.3534,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_dii_1596_3872",
    x: 91.4354,
    y: 167.769,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_dii_1596_3872",
    x: 68.8104,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_dii_1596_3872",
    x: 83.8963,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_dii_1596_3872",
    x: 76.3534,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_dii_1596_3872",
    x: 91.4354,
    y: 175.892,
    width: 8.13337,
    height: 8.13435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_dii_1596_3872",
    x: 105.693,
    y: 167.769,
    width: 16.2545,
    height: 16.2554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0 0.238636 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1596_3872",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.816667 0 0 0 0 0.816667 0 0 0 0 0.816667 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1596_3872",
    result: "effect3_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_ii_1596_3872",
    x: 107.783,
    y: 170.284,
    width: 7.64486,
    height: 7.64583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_ii_1596_3872",
    x: 111.303,
    y: 173.804,
    width: 7.64486,
    height: 7.64583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0 0.999242 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_ii_1596_3872",
    x: 105.693,
    y: 122.339,
    width: 15.8285,
    height: 29.9945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.488514,
    dy: 0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1596_3872"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.488514,
    dy: -0.488514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.17098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1596_3872",
    result: "effect2_innerShadow_1596_3872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1596_3872",
    x1: 65.245,
    y1: 22.5342,
    x2: 65.245,
    y2: 33.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1596_3872",
    x1: 82.0968,
    y1: 0,
    x2: 82.0968,
    y2: 9.28176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1596_3872",
    x1: 94.3116,
    y1: 0,
    x2: 94.3116,
    y2: 9.28176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1596_3872",
    x1: 112.14,
    y1: 0,
    x2: 112.14,
    y2: 9.28176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#EC938B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C64638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#C95343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D47C66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup900);
export default __webpack_public_path__ + "static/media/Group 900.17be1c6cffda7bb60e44fc2ec425192d.svg";
export { ForwardRef as ReactComponent };